window.logoData = {
  "RSC106.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_NavyPink_3.jpg?v=1766066098",
    "canvas": "1064_1299_588_544",
    "defaultPlacement": "1260_1526_162_162",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1116",
      "1640",
      "1118",
      "1800"
    ]
  },
  "BP109.FrontPocket": {
    "location": "Front Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Jones-Varsity-Backpack-LG-2048_bc22004e-787a-4d6a-8826-f0c7bff7c6a7.jpg?v=1734748945",
    "canvas": "611_1102_862_711",
    "defaultPlacement": "875_1200_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1934",
      "1800"
    ]
  },
  "RB139.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Kodiak_1.jpg?v=1736533849",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "BP503.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_ba5da8ae-5c4a-4ccb-a225-633325dc4920.jpg?v=1735605671",
    "canvas": "939_616_250_250",
    "defaultPlacement": "969_646_215_215",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1138",
      "1578",
      "1801",
      "1640",
      "1800"
    ]
  },
  "DF603.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ScoutDuff_Charcoal-4.jpg?v=1760634186",
    "canvas": "469_901_1109_674",
    "defaultPlacement": "948_1122_225_225",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1934",
      "1640"
    ]
  },
  "HD105.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/GoodieBagR_Navy1_6d762bd5-5da4-4d88-a6fe-485084cebfc8.jpg?v=1734748858",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "808_1075_393_393",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "BP201.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_d508266c-548a-4e63-89be-e765ee931c16.jpg?v=1735361239",
    "canvas": "795_882_456_441",
    "defaultPlacement": "869_958_290_290",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1845",
      "1800"
    ]
  },
  "RSC204.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_Charcoal_2.jpg?v=1736282060",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_810_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "RSC209.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Cedar-2.jpg?v=1760326443",
    "canvas": "980_620_700_700",
    "defaultPlacement": "1270_820_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1255",
      "1801",
      "1559"
    ]
  },
  "BP445.UpperPocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Fescue-1.jpg?v=1760325417",
    "canvas": "677_418_690_336",
    "defaultPlacement": "940_565_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1822",
      "1969",
      "1801",
      "1255"
    ]
  },
  "HD107.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/GoodieBagR_OliveClayGreen1.jpg?v=1708716079",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "819_1049_400_400",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1098",
      "1082",
      "1969"
    ]
  },
  "UT239.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Cobalt_2.jpg?v=1736529793",
    "canvas": "1193_758_305_238",
    "defaultPlacement": "1270_785_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1137",
      "1134"
    ]
  },
  "JT107.Back": {
    "location": "Back",
    "picture": "",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "897_1250_252_252",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "GR213.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_cde8d980-b7ab-4008-83d2-39d66e2e9ea0.jpg?v=1735353526",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "819_911_442_442",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1801",
      "1934",
      "1086"
    ]
  },
  "BP601.FrontPocket": {
    "location": "Front Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Varsity-Backpack-Moss1copy_ae376fdf-0d85-4aa8-9332-3a6f2185761f.jpg?v=1734748399",
    "canvas": "611_1102_862_711",
    "defaultPlacement": "850_1275_269_269",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1856",
      "1648"
    ]
  },
  "FM25005-0202.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodie_Citadel-4.jpg?v=1757419862",
    "canvas": "935_637_157_128",
    "defaultPlacement": "959_648_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1242",
      "1118",
      "1800",
      "1360"
    ]
  },
  "UT405.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Navy-3.jpg?v=1760378109",
    "canvas": "299_476_1385_778",
    "defaultPlacement": "675_800_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1375",
      "1243"
    ]
  },
  "RNS103.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CementCobalt_2.jpg?v=1736282343",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1086",
      "1137",
      "1800",
      "1801",
      "1076"
    ]
  },
  "RB139.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Kodiak_3.jpg?v=1737046138",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "DK410.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_359b00d4-33cd-4220-9b64-a1793d7733eb.jpg?v=1735361591",
    "canvas": "710_760_440_440",
    "defaultPlacement": "792_846_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "BP418.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_LeCremeOlive_1.jpg?v=1736288227",
    "canvas": "677_418_690_400",
    "defaultPlacement": "936_580_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1969",
      "1056",
      "1801",
      "1072"
    ]
  },
  "RSC205.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JonesSportsCo_Rover_Navy9_Wholesale.jpg?v=1761045762",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_825_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "HD102.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Jones-Goodie-Bag-Charcoal-1_1b6ef7e5-5b53-4f45-9fdb-de84d3dfb56b.jpg?v=1771280057",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "846_1019_400_400",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1147",
      "1801",
      "1934",
      "1640"
    ]
  },
  "RSC201.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_DG-5.jpg?v=1753025826",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1265_840_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1578",
      "1103"
    ]
  },
  "DF202-1.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_15b3db3f-780d-4cc6-9faa-f6e649a8562f.jpg?v=1735353651",
    "canvas": "783_935_340_340",
    "defaultPlacement": "803_955_318_318",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1147",
      "1934",
      "1640"
    ]
  },
  "BP109.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_f032a053-049a-4cce-b37c-26e4c9001e8f.jpg?v=1735353648",
    "canvas": "612_251_797_711",
    "defaultPlacement": "875_392_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "RNS203.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_OliveLeCreme_1.jpg?v=1736282596",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1072",
      "1056",
      "1801",
      "1969"
    ]
  },
  "UT244.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_BlackRed_1.jpg?v=1736533470",
    "canvas": "385_433_1097_771",
    "defaultPlacement": "623_754_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1147",
      "1801",
      "1118",
      "1858",
      "1800"
    ]
  },
  "FM25005-0500.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_RangeHoodie-Cab_1.jpg?v=1768675011",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1640",
      "1567"
    ]
  },
  "BP604.FrontPocket": {
    "location": "Front Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_PHC_VarsityBackpack_Espresso1.jpg?v=1745946768",
    "canvas": "611_1102_862_711",
    "defaultPlacement": "890_1260_270_270",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1072",
      "1257",
      "1130"
    ]
  },
  "Test": {
    "location": "",
    "picture": "",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "___",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "BP117.FrontPocket": {
    "location": "Front Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Jones-Varsity-Backpack-Black-1_587fd00f-9cc2-4ab4-8674-c8513c98a0d1.jpg?v=1734748574",
    "canvas": "611_1102_862_711",
    "defaultPlacement": "917_1300_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "FM26027-0104.BackLeftPocket": {
    "location": "Back Left Pocket",
    "picture": "",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "FM25001-0302.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_WindblockerLoden_1.jpg?v=1768675014",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1955",
      "1156"
    ]
  },
  "GR219.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_DarkGreen_2.jpg?v=1771248071",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "787_931_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1086",
      "1800",
      "1801",
      "1578",
      "1103"
    ]
  },
  "DF502.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_63c6c308-52a0-4277-8b9c-47ed1be5725b.jpg?v=1735353466",
    "canvas": "897_920_295_295",
    "defaultPlacement": "897_920_281_281",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "GJ114.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Stripeshow_2.jpg?v=1736375190",
    "canvas": "500_456_1000_950",
    "defaultPlacement": "1288_736_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "UTF302.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_157b71f0-7c75-46d4-8f76-7d6fe20cb048.jpg?v=1735353452",
    "canvas": "894_1081_263_280",
    "defaultPlacement": "894_1081_263_263",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1640",
      "1243"
    ]
  },
  "GR225.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_Charcoal_1.jpg?v=1737046185",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "831_946_445_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "RSC201.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_DG-6.jpg?v=1753025826",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "RNS204.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_SoftBlue-Navy_2.jpg?v=1736281623",
    "canvas": "1080_620_554_550",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1953",
      "1147",
      "1801",
      "1118",
      "1243"
    ]
  },
  "RSC103.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_DarkGreen_2.jpg?v=1736272833",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_799_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1578",
      "1103"
    ]
  },
  "RB139.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Kodiak_2.jpg?v=1737046138",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "RB145.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_HeritageGreen_3.jpg?v=1737046135",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1640",
      "1390"
    ]
  },
  "UTWD304.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_516360b0-95df-4932-8789-9a50b5f68b82.jpg?v=1735353438",
    "canvas": "810_900_270_270",
    "defaultPlacement": "851_1000_230_230",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1118",
      "1670"
    ]
  },
  "RSC206.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Bone-3.jpg?v=1771866708",
    "canvas": "1054_1322_588_544",
    "defaultPlacement": "1268_1526_162_162",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1639",
      "1118",
      "1822"
    ]
  },
  "UT415.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_DarkGreen-3.jpg?v=1760378244",
    "canvas": "299_476_1385_778",
    "defaultPlacement": "685_811_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1578",
      "1103"
    ]
  },
  "GR222.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_ab5960c1-3d3b-4e6c-b808-1c414b9deb43.jpg?v=1735353522",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "792_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "UT402.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_HeritageTrouper_Evergreen-4.jpg?v=1758172876",
    "canvas": "315_528_1255_629",
    "defaultPlacement": "650_770_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1118",
      "1390"
    ]
  },
  "TX102.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Navy-2.jpg?v=1760524555",
    "canvas": "911_607_977_619",
    "defaultPlacement": "1325_855_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1041",
      "1640",
      "1375",
      "1243"
    ]
  },
  "HD114.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_33f385b9-4c68-427a-b2ba-68166956cef0.jpg?v=1735361679",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "821_1069_397_397",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1856",
      "1648",
      "1084"
    ]
  },
  "UT413.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Fescue-5.jpg?v=1760378449",
    "canvas": "978_996_723_758",
    "defaultPlacement": "1275_1270_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1559",
      "1255"
    ]
  },
  "DF222.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_32e40cb4-2244-4126-b05c-65458606e325.jpg?v=1735353681",
    "canvas": "829_912_350_350",
    "defaultPlacement": "849_912_326_326",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1147",
      "1800"
    ]
  },
  "GR301.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_3d9ca0ef-99a8-42df-9e16-eef085b76c37.jpg?v=1735361588",
    "canvas": "480_777_1087_887",
    "defaultPlacement": "892_1046_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1147",
      "1801",
      "1118",
      "1640"
    ]
  },
  "CS100-Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/ClassicStand_Black_2_1_bafaca72-1d53-439e-a9f9-97e8283e7368.jpg?v=1733945303",
    "canvas": "1100_591_650_300",
    "defaultPlacement": "782_755_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1148",
      "1161",
      "1167",
      "1169",
      "1158"
    ]
  },
  "UTWD303.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/WeekenderDuffle_Charcoal_1.jpg?v=1736353297",
    "canvas": "870_980_370_300",
    "defaultPlacement": "912_1024_215_215",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1977",
      "1640"
    ]
  },
  "BP427.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_CementCobalt_2.jpg?v=1736288611",
    "canvas": "625_510_799_536",
    "defaultPlacement": "940_707_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1134",
      "1800",
      "1801",
      "1640",
      "1086"
    ]
  },
  "UTJ203.Right Side": {
    "location": "Right Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_Side.jpg?v=1735361397",
    "canvas": "545_917_675_180",
    "defaultPlacement": "668_926_160_160",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "GR207.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_Camo_2.jpg?v=1737046185",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "809_978_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "BP502.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_55137d1e-e1d7-4305-8dd3-21169e8dfa33.jpg?v=1735353505",
    "canvas": "994_537_250_250",
    "defaultPlacement": "1024_567_200_200",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1225",
      "1673"
    ]
  },
  "UTF402.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Backside_be9592b2-90e3-4512-98af-3a3a5f581195.jpg?v=1735361606",
    "canvas": "450_823_1216_980",
    "defaultPlacement": "892_1278_243_243",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1845",
      "1800"
    ]
  },
  "BP449.UnderFlap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_OliveGray-Fescue-2.jpg?v=1760326615",
    "canvas": "625_510_799_536",
    "defaultPlacement": "950_660_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1668",
      "1987",
      "1800",
      "1801",
      "1255"
    ]
  },
  "RB146.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Ranger_Oxford_1.jpg?v=1749656671",
    "canvas": "492_495_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1800",
      "1243"
    ]
  },
  "RNS209.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_CedarFescue-1.jpg?v=1760326476",
    "canvas": "231_586_887_593",
    "defaultPlacement": "625_850_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1822",
      "1559",
      "1801",
      "1255"
    ]
  },
  "HD112.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Goodie-Bag-Moss-2.jpg?v=1727814108",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "833_1050_397_397",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1856",
      "1648"
    ]
  },
  "GR218.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_47289d09-2878-4950-9729-12beb1978bc6.jpg?v=1734670702",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "790_953_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "GJ129.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Bomber_2.jpg?v=1736374085",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_767_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "GR212.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_029bc6bd-2082-4e1b-ac5d-24a04019f834.jpg?v=1735353516",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "776_938_430_430",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1147",
      "1801",
      "1118",
      "1858",
      "1800"
    ]
  },
  "TX106.RightSide": {
    "location": "Right Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_ScoutOlive-1.jpg?v=1768602651",
    "canvas": "253_564_1264_684",
    "defaultPlacement": "535_814_185_185",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1856",
      "1969"
    ]
  },
  "UT409.Front": {
    "location": "Front",
    "picture": "",
    "canvas": "978_996_723_758",
    "defaultPlacement": "1275_1285_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "DF501.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap.jpg?v=1735353464",
    "canvas": "797_801_425_425",
    "defaultPlacement": "797_801_408_408",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "RNS205.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Seacrest-2.jpg?v=1760325417",
    "canvas": "1010_600_650_650",
    "defaultPlacement": "1275_850_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1246",
      "1118",
      "1800",
      "1975"
    ]
  },
  "UTWD402.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_WeekenderDuff_Charc_2-1.jpg?v=1749745810",
    "canvas": "501_785_1037_688",
    "defaultPlacement": "905_1015_230_230",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1977",
      "1640"
    ]
  },
  "DF218.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_5bc16d39-4fec-4d16-b8c9-eb4e0b26bad1.jpg?v=1735353658",
    "canvas": "824_788_380_380",
    "defaultPlacement": "864_808_352_352",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "UT238.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Charcoal_1.jpg?v=1736529430",
    "canvas": "368_466_1097_771",
    "defaultPlacement": "610_757_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "GR214.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_cce20753-6cd2-4a81-959d-ab22ebe98899.jpg?v=1735353517",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "795_968_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1118",
      "1274",
      "1112",
      "1086"
    ]
  },
  "BP430.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_MoonGrayNavy_1.jpg?v=1736287567",
    "canvas": "566_1231_905_631",
    "defaultPlacement": "906_1453_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "BP440.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_MoonGrayRS-1-2.jpg?v=1764105948",
    "canvas": "621_1297_805_571",
    "defaultPlacement": "919_1478_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1274",
      "1086"
    ]
  },
  "UT245.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_NavySoftBlue_1.jpg?v=1736533410",
    "canvas": "1000_588_714_554",
    "defaultPlacement": "1268_775_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1953",
      "1147",
      "1801",
      "1118",
      "1243"
    ]
  },
  "RB127.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_LeCreme_3.jpg?v=1737046137",
    "canvas": "850_762_460_460",
    "defaultPlacement": "860_772_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1072"
    ]
  },
  "RB116.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_AllBlack_1_26977e1b-7519-40ef-9bab-8de60f2ef00f.jpg?v=1736533850",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "820_730_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1858",
      "1800"
    ]
  },
  "BP429.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_BlackCharcoalRed_2.jpg?v=1736288097",
    "canvas": "625_510_799_536",
    "defaultPlacement": "929_700_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1147",
      "1118",
      "1800"
    ]
  },
  "FM26020-0101.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WBVest_Bone-1.jpg?v=1773794803",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1199_748_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1970",
      "1955",
      "1072"
    ]
  },
  "GR244.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_CGOG-1.jpg?v=1769734003",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "812_970_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1668",
      "1800",
      "1801",
      "1640",
      "1118"
    ]
  },
  "FM26027-0101.BackLeftPocket": {
    "location": "Back Left Pocket",
    "picture": "",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "RSN104.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_BlackSageLeaf_3.jpg?v=1753027643",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1116",
      "1578"
    ]
  },
  "RSC106.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_NavyPink_2.jpg?v=1736282760",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1116",
      "1640",
      "1118",
      "1800"
    ]
  },
  "PS211.LeftApparelPocket": {
    "location": "Left Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_PlayersSeries_DarkGreen-4.jpg?v=1773695087",
    "canvas": "993_985_630_375",
    "defaultPlacement": "1249_1130_116_116",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1118",
      "1390"
    ]
  },
  "RSC207.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Graystone-2.jpg?v=1760326335",
    "canvas": "950_620_740_700",
    "defaultPlacement": "1260_875_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1668",
      "1041"
    ]
  },
  "GJ103.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Navy_2.jpg?v=1736374957",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_767_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "FM26001-0101.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_FTQZ_Bone-4.jpg?v=1773794824",
    "canvas": "923_756_120_120",
    "defaultPlacement": "923_756_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1970",
      "1955",
      "1072"
    ]
  },
  "DK306.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_0eaf0da9-3369-4c35-a21d-a94386103142.jpg?v=1735353432",
    "canvas": "830_800_360_360",
    "defaultPlacement": "860_828_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1116",
      "1098"
    ]
  },
  "GJ141.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Kodiak_3.jpg?v=1736375132",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1060_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "FM25005-0002.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_RangeHoodie-JB_1.jpg?v=1768675011",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1955",
      "1800"
    ]
  },
  "RB129.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_ClayGreen_2.jpg?v=1737046138",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1116",
      "1098"
    ]
  },
  "BP440.UnderFlap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_MoonGrayRS-2-2.jpg?v=1764105948",
    "canvas": "624_538_799_536",
    "defaultPlacement": "929_684_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1274",
      "1086"
    ]
  },
  "GR244.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_CGOG-2.jpg?v=1769734003",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_965_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1668",
      "1800",
      "1801",
      "1640",
      "1118"
    ]
  },
  "PS101.RightApparelPocket": {
    "location": "Right Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/PlayersSeries_001_4.jpg?v=1768417055",
    "canvas": "393_1072_630_375",
    "defaultPlacement": "645_1154_129_129",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1858",
      "1800"
    ]
  },
  "RB135.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_b0a39b33-daea-4aa1-88cb-67b2e029627d.png?v=1735353544",
    "canvas": "810_690_460_460",
    "defaultPlacement": "820_700_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "BP429.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_BlackCharcoalRed_1.jpg?v=1736288097",
    "canvas": "677_418_690_336",
    "defaultPlacement": "934_552_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1147",
      "1801",
      "1118",
      "1640"
    ]
  },
  "PS207.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_9ffae734-e9ae-4379-80ae-e981cf88d4ad.jpg?v=1735361641",
    "canvas": "1065_590_636_458",
    "defaultPlacement": "1308_763_130_130",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1856",
      "1648",
      "1084"
    ]
  },
  "DF226.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_a5c70430-079b-4548-834f-6da37d237170.jpg?v=1735353678",
    "canvas": "814_922_370_370",
    "defaultPlacement": "834_942_345_345",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1225",
      "1673"
    ]
  },
  "GJ129.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Bomber_3.jpg?v=1736374085",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1007_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "SB103.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_06c8f842-c583-472f-a8c3-e9b02d0b4e9f.jpg?v=1735353407",
    "canvas": "176_75_1695_1897",
    "defaultPlacement": "871_916_320_320",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "JT103.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_EssToteBack_CG_0d28648b-87b8-4c91-85b4-2ed32e5be30f.jpg?v=1744929322",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "894_1247_255_255",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1116",
      "1098"
    ]
  },
  "UT235.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_ee9074e7-2013-465b-9ca6-7c302cde00bb.png?v=1735353602",
    "canvas": "1193_758_305_238",
    "defaultPlacement": "1253_767_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1116",
      "1578"
    ]
  },
  "BP439.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_DarkGreenRS-1.jpg?v=1749557796",
    "canvas": "573_1267_881_530",
    "defaultPlacement": "940_1460_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1955",
      "1390"
    ]
  },
  "JT203.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_9a972cf4-d990-414b-8228-bbe708b62fba.jpg?v=1735361692",
    "canvas": "501_923_1018_827",
    "defaultPlacement": "926_1109_228_228",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1856",
      "1648",
      "1084"
    ]
  },
  "SB102.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_a6c49147-7a53-4b0c-9454-d9e49a1fc90d.jpg?v=1735353406",
    "canvas": "780_900_450_450",
    "defaultPlacement": "875_964_320_320",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1858",
      "1118"
    ]
  },
  "RSC205.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JonesSportsCo_Rover_Navy8_Wholesale.jpg?v=1761045762",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "BP603.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_4439dfbc-b6f3-4c77-83a8-a3b91e40f849.jpg?v=1735361654",
    "canvas": "612_251_797_711",
    "defaultPlacement": "890_434_270_270",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1856",
      "1648",
      "1084"
    ]
  },
  "RSC205.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JonesSportsCo_Rover_Navy10_Wholesale.jpg?v=1761045762",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "FM25001-0002.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_WindblockerJB_1.jpg?v=1768675014",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1955",
      "1800"
    ]
  },
  "UT405.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Navy-5.jpg?v=1760378109",
    "canvas": "978_996_723_758",
    "defaultPlacement": "1290_1280_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1375",
      "1243"
    ]
  },
  "SD201.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ScoutDuffle_Olive-2.jpg?v=1755131528",
    "canvas": "495_740_1057_737",
    "defaultPlacement": "930_1029_225_225",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1856",
      "1969"
    ]
  },
  "BP447.UnderFlap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Seacrest-2.jpg?v=1760326674",
    "canvas": "625_510_799_536",
    "defaultPlacement": "939_670_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1975",
      "1801",
      "1800",
      "1118",
      "1246"
    ]
  },
  "UT236.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Black_1.jpg?v=1736529495",
    "canvas": "340_412_1097_771",
    "defaultPlacement": "606_754_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "DF502.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_fbcb1973-88fc-4603-a1f6-6aa0b1168042.jpg?v=1735353466",
    "canvas": "827_793_440_440",
    "defaultPlacement": "827_793_426_426",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "GR224.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_67ba6d05-ff1b-41c5-b399-3dde41d73e62.jpg?v=1735361558",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "829_960_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "CS101.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/ClassicStand_Black_2.jpg?v=1736534261",
    "canvas": "943_775_470_207",
    "defaultPlacement": "1085_780_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1934",
      "1800"
    ]
  },
  "DF208-1.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_Black_1.jpg?v=1736356205",
    "canvas": "870_975_320_320",
    "defaultPlacement": "917_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1934",
      "1800"
    ]
  },
  "JT204.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_PHC_Tote_Espresso2_6fbfca14-16cc-4655-811a-6360066efe17.jpg?v=1753197047",
    "canvas": "501_923_1018_827",
    "defaultPlacement": "926_1125_228_228",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1072",
      "1257",
      "1130"
    ]
  },
  "JT107.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Essential_Tote_Charcoal.jpg?v=1776167639",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "897_1250_252_252",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "RNS110.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CorduraCamo_2_d1b2024c-d22c-4cd3-a671-51e41f3238cf.jpg?v=1736282840",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "UTC303.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_70391053-d2b9-4d1b-aea5-19e1281c5f3a.jpg?v=1735353640",
    "canvas": "259_402_1554_1460",
    "defaultPlacement": "827_927_421_421",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1977",
      "1640"
    ]
  },
  "UT407.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_OliveNight-5.jpg?v=1760378275",
    "canvas": "978_996_723_758",
    "defaultPlacement": "1268_1285_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1871",
      "1118",
      "1640",
      "1795"
    ]
  },
  "BP407.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_MoonGray_1.jpg?v=1736288169",
    "canvas": "615_1246_846_596",
    "defaultPlacement": "935_1477_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1274",
      "1086"
    ]
  },
  "BP425.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_BlackSageLeaf_1.jpg?v=1736286754",
    "canvas": "573_1267_881_530",
    "defaultPlacement": "915_1460_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1138",
      "1801",
      "1640",
      "1578"
    ]
  },
  "DF602.Back": {
    "location": "Back",
    "picture": "",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "___",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "PSB101.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TwoShoeBag_Black-1_5f2c0d17-296b-4f49-80b3-414f0c4fa735.jpg?v=1771978476",
    "canvas": "233_75_1695_1897",
    "defaultPlacement": "933_926_295_295",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1084",
      "1640",
      "1106",
      "1800"
    ]
  },
  "FM25002-0401.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindPullM_Sand-1.jpg?v=1757419760",
    "canvas": "1144_637_157_128",
    "defaultPlacement": "1168_648_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1970",
      "1955",
      "1568"
    ]
  },
  "BP441.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_NavyRS-2.jpg?v=1755256634",
    "canvas": "625_510_799_536",
    "defaultPlacement": "929_639_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "PS207.LeftApparelPocket": {
    "location": "Left Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/PlayersSeries-Canvas-6_6b08fe94-542b-4ae3-8ee0-cad3250cb446.jpg?v=1734748390",
    "canvas": "989_968_636_458",
    "defaultPlacement": "1240_1130_130_130",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1856",
      "1648",
      "1084"
    ]
  },
  "DF203-1.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_826cb96d-6cb0-4f2a-b7b9-9ccfbdf40008.jpg?v=1735353667",
    "canvas": "840_1027_265_265",
    "defaultPlacement": "860_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "RB143.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Ranger26_AllBlack-2.jpg?v=1767741037",
    "canvas": "492_449_1053_949",
    "defaultPlacement": "820_715_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "TX103.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Durham-3_Blk.jpg?v=1761259330",
    "canvas": "827_1025_757_819",
    "defaultPlacement": "1130_1350_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1987",
      "1118",
      "1640",
      "1800"
    ]
  },
  "UTF305.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FieldTote_Black1_917bf739-e38f-4eee-a890-6a3c98b0f77e.jpg?v=1737429610",
    "canvas": "450_823_1216_980",
    "defaultPlacement": "900_1130_252_252",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "FM26020-0402.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_WindblockerVestWheat_1.jpg?v=1768675010",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1156",
      "1792"
    ]
  },
  "FM26033-0104.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_RangeQuarter-Heather_1.jpg?v=1768675009",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1955",
      "1118"
    ]
  },
  "UTF401.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Backside_59c36369-e88b-449a-8fed-4d0c011e7031.jpg?v=1735361606",
    "canvas": "926_1246_243_260",
    "defaultPlacement": "926_1246_243_243",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1147",
      "1800"
    ]
  },
  "GR221.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_Splatter_2.jpg?v=1737046185",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "792_973_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1977",
      "1990",
      "1024",
      "1800"
    ]
  },
  "TL115.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_d00e1f6b-35b1-4236-ab2e-8e3f8b1686c5.jpg?v=1735361634",
    "canvas": "515_1430_895_604",
    "defaultPlacement": "627_1785_108_108",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "HW202.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Handwarmer_Navy-1.jpg?v=1749557902",
    "canvas": "495_836_1057_737",
    "defaultPlacement": "890_1085_285_285",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1640",
      "1243"
    ]
  },
  "List 1": {
    "location": "",
    "picture": "",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "___",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "UT236.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Black_2.jpg?v=1736529495",
    "canvas": "988_563_714_554",
    "defaultPlacement": "1265_767_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "RSC204.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_Charcoal_1.jpg?v=1736282060",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "JT202.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_33395109-3d57-4b4a-bf01-17eb8c7de26d.jpg?v=1735361682",
    "canvas": "501_923_1018_827",
    "defaultPlacement": "912_1131_228_228",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1648",
      "1899"
    ]
  },
  "PS205.LeftApparelPocket": {
    "location": "Left Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Jones-Players-Series-Olive-R-3_dfc008ac-631b-4d39-b4e3-c2378746863e.jpg?v=1734748680",
    "canvas": "989_968_636_458",
    "defaultPlacement": "1260_1175_130_130",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1856",
      "1969"
    ]
  },
  "GR240.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_OliveGray-1.jpg?v=1760326990",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_975_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1255",
      "1987",
      "1801",
      "1800",
      "1668"
    ]
  },
  "UT232.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_515da4df-9924-4bc1-80cb-74602630dfb6.jpg?v=1735353606",
    "canvas": "484_774_510_231",
    "defaultPlacement": "631_769_199_199",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "RNS206.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_OliveNightBone-3_297453fc-45c1-4eff-86b3-6b66ef21b4e6_1.jpg?v=1760325417",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1871",
      "1118",
      "1800",
      "1795"
    ]
  },
  "BP428.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_SoftBlueNavy_1.jpg?v=1736288370",
    "canvas": "581_1245_839_598",
    "defaultPlacement": "906_1453_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1953",
      "1147",
      "1801",
      "1118",
      "1243"
    ]
  },
  "RB103.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Navy_1.jpg?v=1736533849",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "820_730_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "FM26029-0101.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_CottonRangeCrew-Bone_1.jpg?v=1768675008",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1955",
      "1072"
    ]
  },
  "GJ142.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Camo_1_f12cfb79-9606-400c-ac4d-63776cc8e01e.jpg?v=1737039126",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_749_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "FM25005-0201.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodie_DutchB-4.jpg?v=1773795645",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "929_637_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1955",
      "1642"
    ]
  },
  "GR219.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_03f4c7b3-a853-4b43-b673-bab8401ceafa.jpg?v=1735353519",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "787_931_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1086",
      "1800",
      "1801",
      "1578",
      "1103"
    ]
  },
  "BP419.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_BlackWheat_1.jpg?v=1736288670",
    "canvas": "573_1267_881_530",
    "defaultPlacement": "906_1453_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1640",
      "1673"
    ]
  },
  "DK415.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_cc01bf8f-9c5d-4028-b1dd-12488898f667.jpg?v=1735353429",
    "canvas": "770_840_430_430",
    "defaultPlacement": "841_909_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "HB103.Top": {
    "location": "Top",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Top_879d9c1e-0c40-4fe8-b415-1c750daf492d.jpg?v=1735353462",
    "canvas": "818_851_430_430",
    "defaultPlacement": "848_881_370_370",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1118"
    ]
  },
  "TX104.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Bone-2.jpg?v=1760524555",
    "canvas": "911_607_977_619",
    "defaultPlacement": "1325_865_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1255",
      "1041",
      "1801",
      "1822"
    ]
  },
  "SWB102.Front(o)": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ScoutWeekenderBackpack_Olive.jpg?v=1745502658",
    "canvas": "846_905_427_408",
    "defaultPlacement": "940_990_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1856",
      "1969"
    ]
  },
  "UT251.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper3.0_Azure-6.jpg?v=1749246854",
    "canvas": "964_974_725_768",
    "defaultPlacement": "1232_1264_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1082",
      "1801",
      "1640",
      "1175"
    ]
  },
  "GR303.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrunkCaddy_DarkGreen-2.jpg?v=1749246923",
    "canvas": "480_777_1087_887",
    "defaultPlacement": "895_1048_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1955",
      "1390"
    ]
  },
  "RB146.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Ranger_Oxford_4.jpg?v=1749656671",
    "canvas": "445_483_1053_949",
    "defaultPlacement": "773_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1800",
      "1243"
    ]
  },
  "UT411.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Bone-4.jpg?v=1760378307",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1242_833_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1919",
      "1801",
      "1640",
      "1822"
    ]
  },
  "BP502.Top": {
    "location": "Top",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Top_62cb7ad8-6a1b-4b04-a8d3-f01d98de561f.jpg?v=1735353505",
    "canvas": "853_280_300_300",
    "defaultPlacement": "873_300_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1225",
      "1673"
    ]
  },
  "BP449.LowerPocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_OliveGray-Fescue-1.jpg?v=1760326615",
    "canvas": "550_1177_981_748",
    "defaultPlacement": "965_1455_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1255",
      "1987",
      "1801",
      "1800",
      "1668"
    ]
  },
  "DF603.Top": {
    "location": "Top",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ScoutDuff_Charcoal-3.jpg?v=1760634186",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "___",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1934",
      "1640"
    ]
  },
  "UT405.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Navy-4.jpg?v=1760378109",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1242_813_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1375",
      "1243"
    ]
  },
  "BP420.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_MoonGrayBlack_1.jpg?v=1736288328",
    "canvas": "677_418_690_390",
    "defaultPlacement": "942_557_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1851",
      "1086"
    ]
  },
  "FM26021-0103.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodieLite_Bone-4.jpg?v=1773873297",
    "canvas": "990_637_157_128",
    "defaultPlacement": "1010_648_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1955",
      "1970",
      "1801"
    ]
  },
  "FM25001-0300.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_Windblocker_NS-4.jpg?v=1773852474",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "946_637_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1955",
      "1371"
    ]
  },
  "RB143.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Ranger26_AllBlack-1_a9c4fc3f-97f7-4290-a07f-e7053a1abb4d.jpg?v=1767799618",
    "canvas": "492_449_1053_949",
    "defaultPlacement": "805_725_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "FM26033-0200.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_RangeQuarter-PB_1.jpg?v=1768675010",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1041",
      "1801",
      "1640",
      "1955",
      "1242"
    ]
  },
  "FM25001-0202.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindBlockerM_Citadel-4.jpg?v=1757419695",
    "canvas": "973_612_157_128",
    "defaultPlacement": "997_621_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1242",
      "1118",
      "1800",
      "1360"
    ]
  },
  "GR239.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Bone-Cedar-1.jpg?v=1760325416",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1559",
      "1800",
      "1118",
      "1255",
      "1822"
    ]
  },
  "JT116.Back": {
    "location": "Back",
    "picture": "",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "860_1181_251_251",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1969",
      "1336",
      "1072"
    ]
  },
  "CS101.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/ClassicStand_Black_1.jpg?v=1736534261",
    "canvas": "601_755_470_192",
    "defaultPlacement": "782_765_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1934",
      "1800"
    ]
  },
  "UT417.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Ecru-4.jpg?v=1771866505",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1242_833_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1255",
      "1622"
    ]
  },
  "DF602.Top": {
    "location": "Top",
    "picture": "",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "___",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "RD207.Upper Belly": {
    "location": "Upper Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/AllBlack-Rider.jpg?v=1739830674",
    "canvas": "610_559_897_676",
    "defaultPlacement": "960_808_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "RB138.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Charcoal_2.jpg?v=1737046139",
    "canvas": "492_449_1053_949",
    "defaultPlacement": "820_725_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1147",
      "1640"
    ]
  },
  "UTC309.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_UtilityCooler26_Fescue-1.jpg?v=1760326740",
    "canvas": "259_402_1554_1460",
    "defaultPlacement": "820_927_421_421",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1255"
    ]
  },
  "UTF303.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_8c7e05ed-ddd9-4f58-b107-6539201a9409.jpg?v=1735353448",
    "canvas": "877_1101_269_285",
    "defaultPlacement": "877_1101_269_269",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1934",
      "1640"
    ]
  },
  "RD201.MiddleBelly": {
    "location": "Middle Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Belly_777dfb6e-e21b-4a85-977a-d06546ce9dd1.jpg?v=1735361615",
    "canvas": "610_839_897_676",
    "defaultPlacement": "970_1088_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1845",
      "1800"
    ]
  },
  "UT254.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper3.0_MidGray-5.jpg?v=1749246983",
    "canvas": "1006_579_714_554",
    "defaultPlacement": "1274_766_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1380",
      "1801",
      "1116",
      "1640"
    ]
  },
  "SD101.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JonesSportsCo_2025_ScoutDuffleNavy_1-1.jpg?v=1743792769",
    "canvas": "495_740_1057_737",
    "defaultPlacement": "930_1104_225_225",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "RD207.Middle Belly": {
    "location": "Middle Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/AllBlack-Rider.jpg?v=1739830674",
    "canvas": "610_839_897_676",
    "defaultPlacement": "960_1088_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "UTC305.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_86d59deb-7d8c-48ed-97d6-5e5a86fb4459.jpg?v=1735353636",
    "canvas": "259_402_1554_1460",
    "defaultPlacement": "851_918_451_451",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "UTWD301.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/WeekenderDuffle_Black_2.jpg?v=1736353297",
    "canvas": "870_1022_250_250",
    "defaultPlacement": "912_1042_207_207",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1147",
      "1118",
      "1800"
    ]
  },
  "RNS103.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CementCobalt_1.jpg?v=1736282343",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1086",
      "1137",
      "1800",
      "1801",
      "1076"
    ]
  },
  "GJ114.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Stripeshow_1.jpg?v=1736375190",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_749_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "BP419.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_BlackWheat_2.jpg?v=1736288670",
    "canvas": "625_510_799_536",
    "defaultPlacement": "929_697_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1673",
      "1118",
      "1640",
      "1800"
    ]
  },
  "RD205.MiddleBelly": {
    "location": "Middle Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Belly_3b641083-7ca0-442f-84bf-c75305a33f7c.jpg?v=1735361608",
    "canvas": "610_839_897_676",
    "defaultPlacement": "924_1088_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "RNS105.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CementBondi_2.jpg?v=1736282399",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1086",
      "1800",
      "1673",
      "1801",
      "1290"
    ]
  },
  "GR114.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_5b8351a4-5079-4775-8ffa-6ec2c4599071.jpg?v=1735353531",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "824_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "UTWD401.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_WeekenderDuff_Black_2-1.jpg?v=1749745810",
    "canvas": "485_958_1037_688",
    "defaultPlacement": "910_1185_230_230",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1147",
      "1800"
    ]
  },
  "GR242.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Durham-2.jpg?v=1771248071",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_968_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1987",
      "1800",
      "1801",
      "1934",
      "1118"
    ]
  },
  "GR235.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_OliveNight-2.jpg?v=1771248072",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "830_975_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1871",
      "1801",
      "1800",
      "1640",
      "1795"
    ]
  },
  "RNS102.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_SoftBlue-Navy_3.jpg?v=1753028225",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1953",
      "1147",
      "1801",
      "1118",
      "1243"
    ]
  },
  "BP114.FrontPocket": {
    "location": "Front Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JonesClassicBackpackcharcoal1.jpg?v=1743723829",
    "canvas": "611_1102_862_711",
    "defaultPlacement": "873_1300_260_260",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1851",
      "1051",
      "1118"
    ]
  },
  "RD211.LowerBelly": {
    "location": "Lower Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Rider_Sonoma.jpg?v=1776256434",
    "canvas": "419_422_1214_1363",
    "defaultPlacement": "939_1324_170_170",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1934",
      "1784"
    ]
  },
  "UT414.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_OliveGray-4.jpg?v=1760378219",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1242_827_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1255",
      "1640",
      "1668"
    ]
  },
  "GJ101.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Black_2.jpg?v=1736374025",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_767_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "UT402.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_HeritageTrouper_Evergreen-5.jpg?v=1758172831",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1245_805_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1118",
      "1390"
    ]
  },
  "JT104.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_d93690b6-c56a-439a-868e-69e6754acc46.png?v=1735353588",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "883_1253_252_252",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "GR302.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/TrunkCaddie_Black_1.jpg?v=1749812395",
    "canvas": "480_777_1087_887",
    "defaultPlacement": "860_1066_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1845",
      "1800"
    ]
  },
  "RSC209.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Cedar-3.jpg?v=1760326443",
    "canvas": "1036_1321_588_544",
    "defaultPlacement": "1249_1512_162_162",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1255",
      "1801",
      "1559"
    ]
  },
  "GJ136.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Charcoal_2.jpg?v=1736374141",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_767_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1640"
    ]
  },
  "DF501.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_1bf5bee7-3812-4323-97e8-8741ef485a8d.jpg?v=1735353463",
    "canvas": "912_957_280_280",
    "defaultPlacement": "912_957_269_269",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "JT116.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_8e1e0c58-244d-43e8-a540-11d0a59fda78.jpg?v=1735353579",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "860_1181_251_251",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1969",
      "1336",
      "1072"
    ]
  },
  "DF228.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_Splatter_1.jpg?v=1736356205",
    "canvas": "880_975_320_320",
    "defaultPlacement": "930_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1977",
      "1990",
      "1024",
      "1800"
    ]
  },
  "RD205.LowerBelly": {
    "location": "Lower Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-White_9bfc6011-5883-4ab5-93bc-e1332621cb08.jpg?v=1734748355",
    "canvas": "596_1142_897_676",
    "defaultPlacement": "924_1368_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "GJ138.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_NavyWhite_2.jpg?v=1736374230",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_767_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "BP406.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_Navy_2.jpg?v=1736287926",
    "canvas": "625_510_799_536",
    "defaultPlacement": "918_675_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "DF217.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_db2425d8-070d-4a36-8c26-7606842e5228.jpg?v=1735353663",
    "canvas": "807_926_385_385",
    "defaultPlacement": "827_946_360_360",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1851",
      "1086"
    ]
  },
  "UT232.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_6d987f5a-fdda-47e5-9c49-0b801854fb2f.jpg?v=1735353606",
    "canvas": "1216_1212_229_314",
    "defaultPlacement": "1228_1265_199_199",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "RNS102.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_SoftBlue-Navy_1.jpg?v=1736281624",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_809_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 4,
    "swatchColor": "",
    "threadCodes": [
      "1953",
      "1147",
      "1801",
      "1118",
      "1243"
    ]
  },
  "FM25001-0402.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_WindblockerWheat_1.jpg?v=1768675014",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1156",
      "1792"
    ]
  },
  "RD203.UpperBelly": {
    "location": "Upper Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Navy-Red-White.jpg?v=1729181060",
    "canvas": "610_559_897_676",
    "defaultPlacement": "960_808_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1147",
      "1118",
      "1640",
      "1243"
    ]
  },
  "SB119.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ClassicShoeBag_OxfordKodiak1.jpg?v=1749595449",
    "canvas": "775_898_508_473",
    "defaultPlacement": "870_975_319_319",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1118",
      "1800",
      "1243"
    ]
  },
  "UT411.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Bone-3.jpg?v=1760378307",
    "canvas": "315_528_1255_629",
    "defaultPlacement": "660_785_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1919",
      "1801",
      "1640",
      "1822"
    ]
  },
  "BP604.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_PHC_VarsityBackpack_Espresso1.jpg?v=1745946768",
    "canvas": "612_251_797_711",
    "defaultPlacement": "900_441_270_270",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1072",
      "1257",
      "1130"
    ]
  },
  "DK402.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_cf331216-70f2-4a97-98cc-c7825c1aaf2f.jpg?v=1735353428",
    "canvas": "810_755_360_360",
    "defaultPlacement": "842_787_303_303",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1856",
      "1072"
    ]
  },
  "RB131.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Sonoma_1.jpg?v=1736533850",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1118",
      "1784"
    ]
  },
  "GR118.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_57106dd6-c707-4173-86c9-0553d53d7adc.jpg?v=1735353529",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "785_919_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "TX107.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Pageant-3.jpg?v=1768602695",
    "canvas": "868_1105_680_748",
    "defaultPlacement": "1116_1387_185_185",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1146",
      "1118",
      "1640",
      "1242"
    ]
  },
  "GJ143.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Moss_2.jpg?v=1736375479",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_767_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1856",
      "1648"
    ]
  },
  "UT409.Left": {
    "location": "Left",
    "picture": "",
    "canvas": "997_605_714_554",
    "defaultPlacement": "1264_793_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "GJ108.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_NavyWhiteRed_3.jpg?v=1736533778",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1035_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1147",
      "1118",
      "1640",
      "1243"
    ]
  },
  "GJ136.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Charcoal_3.jpg?v=1736374140",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1045_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1640"
    ]
  },
  "SCB101.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ShortCourse_Navy-4_df047211-5827-4d19-8cbd-1fa1d1874bc2.jpg?v=1749656930",
    "canvas": "998_634_728_466",
    "defaultPlacement": "1285_790_155_155",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "RB145.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_HeritageGreen_1.jpg?v=1736533849",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1640",
      "1390"
    ]
  },
  "GR227.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_80ae386c-c76c-4a9e-9e30-5df2be5f9e17.jpg?v=1735361541",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "824_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "BP420.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Lower_Pocket_6064de47-baa6-4853-9646-af286d583eda.jpg?v=1735353385",
    "canvas": "540_1290_881_550",
    "defaultPlacement": "845_1515_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1086",
      "1640",
      "1851",
      "1800"
    ]
  },
  "RB138.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Charcoal_3.jpg?v=1737046139",
    "canvas": "492_449_1053_949",
    "defaultPlacement": "820_725_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1147",
      "1640"
    ]
  },
  "DK411.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_PHC_Dopp_Espresso3-1-1.jpg?v=1748400304",
    "canvas": "450_541_1077_769",
    "defaultPlacement": "825_748_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1072",
      "1257",
      "1130"
    ]
  },
  "BP443.Underflap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/IMG_0025-22.jpg?v=1759240970",
    "canvas": "612_516_824_523",
    "defaultPlacement": "943_683_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1243",
      "1118",
      "1800",
      "1485"
    ]
  },
  "GR220.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_NavyFieldKhaki_2.jpg?v=1771248071",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "785_948_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1082",
      "1800",
      "1801",
      "1640",
      "1243"
    ]
  },
  "UTC304.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_cc4b2fe2-24f1-416d-81dd-ce99316642dc.jpg?v=1735353640",
    "canvas": "259_402_1554_1460",
    "defaultPlacement": "815_942_424_424",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1801",
      "1969",
      "1072"
    ]
  },
  "UT407.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_OliveNight-3.jpg?v=1760378275",
    "canvas": "299_476_1385_778",
    "defaultPlacement": "652_811_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1871",
      "1118",
      "1640",
      "1795"
    ]
  },
  "UTWD302.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_72e33479-aa79-4835-8e08-a08243f467a4.jpg?v=1735353445",
    "canvas": "860_1055_250_250",
    "defaultPlacement": "901_1075_218_218",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1858",
      "1243"
    ]
  },
  "GJ146.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_HeritageGreen_2.jpg?v=1736375531",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_767_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1640",
      "1390"
    ]
  },
  "TX106.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_ScoutOlive-3.jpg?v=1768602651",
    "canvas": "748_680_930_1047",
    "defaultPlacement": "1177_1355_185_185",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1856",
      "1969"
    ]
  },
  "FM26033-0002.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_RangeQuarter-JB_1.jpg?v=1768675010",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1955",
      "1800"
    ]
  },
  "UTJ202.Right Side": {
    "location": "Right Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_Side_9c9e6a6e-fd13-4745-b915-2bff5931d296.jpg?v=1735361398",
    "canvas": "545_907_675_230",
    "defaultPlacement": "660_917_160_160",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1578",
      "1103"
    ]
  },
  "GR240.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_OliveGray-2.jpg?v=1771248072",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_975_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1255",
      "1987",
      "1801",
      "1800",
      "1668"
    ]
  },
  "FM25005-0200.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodie_PB-4_fd99d71a-7a2f-4ef5-aa82-49da7bee290b.jpg?v=1773795628",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1000_637_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1578",
      "1800",
      "1118",
      "1242"
    ]
  },
  "RNS208.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Durham-1.jpg?v=1761670973",
    "canvas": "231_586_887_593",
    "defaultPlacement": "625_820_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1987",
      "1801",
      "1640",
      "1118"
    ]
  },
  "SCB101.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ShortCourse_Navy-3_b8ae2013-c42e-4b63-96dd-7f45e64e4fec.jpg?v=1749656930",
    "canvas": "330_612_937_519",
    "defaultPlacement": "645_785_150_150",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "RB141.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_DarkGreen_2.jpg?v=1737046138",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1578",
      "1103"
    ]
  },
  "GR208.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_FieldKhaki_2.jpg?v=1737046184",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "814_995_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1072"
    ]
  },
  "PS210.LeftApparelPocket": {
    "location": "Left Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_PS2048_NavyKodiak-4.jpg?v=1768934531",
    "canvas": "993_985_630_375",
    "defaultPlacement": "1249_1116_116_116",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1118",
      "1243"
    ]
  },
  "RD206.MiddleBelly": {
    "location": "Middle Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Navy1.jpg?v=1729181384",
    "canvas": "610_839_897_676",
    "defaultPlacement": "1001_1088_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "UT250.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper3.0_NavyRip-6_80c18430-1d3e-498d-a9cc-22d3edacd186.jpg?v=1749591906",
    "canvas": "981_972_725_768",
    "defaultPlacement": "1245_1265_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "HB101.Top": {
    "location": "Top",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Top_1a857494-c1ea-4985-9a25-67fe2f2d9e24.jpg?v=1735353460",
    "canvas": "854_824_430_430",
    "defaultPlacement": "884_854_370_370",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "PS208.LeftApparelPocket": {
    "location": "Left Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/HeritagePlayers-Kodiak-4_2445cc73-d547-4797-b7d5-830255a2288d.jpg?v=1734748393",
    "canvas": "989_968_636_458",
    "defaultPlacement": "1290_1130_128_128",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "UTF301.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_bd189909-63f5-4d05-b6d5-ac6ff4c505d3.jpg?v=1735353448",
    "canvas": "923_1153_252_270",
    "defaultPlacement": "923_1153_252_252",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "FM26004-0200.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_PRJNorthSeaBlue_1_e88e5ec9-1f81-44a1-a1f9-28619d763a2d.jpg?v=1767462706",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1242",
      "1955",
      "1801",
      "1118",
      "1371"
    ]
  },
  "SCB103.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ShortCourse_Charcoal-5.jpg?v=1749247861",
    "canvas": "957_1024_683_688",
    "defaultPlacement": "1180_1265_155_155",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "RB116.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Ranger_Black-1.png?v=1762258094",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "830_730_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1858",
      "1800"
    ]
  },
  "UT235.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_f0aac1da-4ffb-43ce-8e25-60872be20226.png?v=1735353601",
    "canvas": "484_554_810_640",
    "defaultPlacement": "631_769_199_199",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1116",
      "1578"
    ]
  },
  "RSC203.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_Olive-6.jpg?v=1749676808",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1359",
      "1801",
      "1147",
      "1969"
    ]
  },
  "FM25001-0400.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_Windblocker_Timber-4.jpg?v=1773795530",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "946_637_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1055",
      "1336"
    ]
  },
  "TX102.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Navy-3.jpg?v=1760524555",
    "canvas": "827_1025_757_819",
    "defaultPlacement": "1145_1350_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1041",
      "1640",
      "1375",
      "1243"
    ]
  },
  "DF224.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_Sonoma_1.jpg?v=1736356206",
    "canvas": "918_1027_265_265",
    "defaultPlacement": "938_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1243",
      "1784"
    ]
  },
  "BP441.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_NavyRS-1.jpg?v=1755256650",
    "canvas": "621_1283_800_560",
    "defaultPlacement": "919_1489_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "RD201.UpperBelly": {
    "location": "Upper Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Black_f7c34224-3adc-4776-a037-ac87c13ca725.jpg?v=1772474440",
    "canvas": "610_559_897_676",
    "defaultPlacement": "970_808_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1845",
      "1800"
    ]
  },
  "FM26033-0104.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_RangeQuarter-Heather_1.jpg?v=1768675009",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1955",
      "1118"
    ]
  },
  "RB133.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_CharcoalR_1.jpg?v=1736533849",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1851",
      "1640"
    ]
  },
  "HB102.Top": {
    "location": "Top",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Top_25294de0-b513-4ea7-9d77-bd9f413de4d4.jpg?v=1735353463",
    "canvas": "890_890_430_430",
    "defaultPlacement": "920_920_370_370",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "RSC207.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Graystone-1.jpg?v=1760326335",
    "canvas": "231_586_887_593",
    "defaultPlacement": "630_860_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1668",
      "1041"
    ]
  },
  "RSC106.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_NavyPink_1.jpg?v=1736282760",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_801_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1116",
      "1640",
      "1118",
      "1800"
    ]
  },
  "PS101.LeftApparelPocket": {
    "location": "Left Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/PlayersSeries_001_3.jpg?v=1730857629",
    "canvas": "989_968_636_458",
    "defaultPlacement": "1250_1140_116_116",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1858",
      "1800"
    ]
  },
  "RNS111.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_OliveLeCreme_2.jpg?v=1736282596",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1072",
      "1056",
      "1801",
      "1969"
    ]
  },
  "GJ114.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Stripeshow_3.jpg?v=1736375190",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1080_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "RNS101.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_BlackWheat_3.jpg?v=1753027379",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1225",
      "1670"
    ]
  },
  "TX101.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Graystone-1.jpg?v=1760327278",
    "canvas": "168_476_1400_830",
    "defaultPlacement": "571_829_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1668",
      "1041"
    ]
  },
  "JT202.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_71a08842-a37a-425d-b34e-d95b7b68b026.jpg?v=1735361602",
    "canvas": "501_923_1018_827",
    "defaultPlacement": "907_1135_228_228",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1648",
      "1899"
    ]
  },
  "UTWD402.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_WeekenderDuff_Charc_3-1.jpg?v=1749745810",
    "canvas": "511_830_1037_688",
    "defaultPlacement": "915_1060_230_230",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1977",
      "1640"
    ]
  },
  "GR216.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_62d52fd3-a5e3-4861-be83-2167c734e391.jpg?v=1735353515",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "787_948_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "BP114.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_cd69390a-e07d-4288-95a1-19a3df1d7529.jpg?v=1735353646",
    "canvas": "612_251_797_711",
    "defaultPlacement": "873_465_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1851",
      "1051",
      "1118"
    ]
  },
  "JT110.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_90a75800-87c2-4ce6-b5d5-f6b6d5f0cb38.png?v=1735353588",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "877_1244_272_272",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1856",
      "1969"
    ]
  },
  "BP443.LowerPocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/IMG_0024-22.jpg?v=1759240970",
    "canvas": "550_1177_981_748",
    "defaultPlacement": "945_1464_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1485",
      "1118",
      "1800",
      "1243"
    ]
  },
  "GJ101.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Black_1.jpg?v=1736374025",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_749_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "GR228.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Oxford-2.jpg?v=1771248072",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "805_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1800",
      "1243"
    ]
  },
  "RD208.Middle Belly": {
    "location": "Middle Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Rider_Clay_Green_1.jpg?v=1776256068",
    "canvas": "610_839_897_676",
    "defaultPlacement": "945_1088_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1116",
      "1098"
    ]
  },
  "RNS109.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CharcoalBlackRed_2.jpg?v=1736282906",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1147",
      "1118",
      "1800"
    ]
  },
  "UT248.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_MoonGray-Olive_1.jpg?v=1736533596",
    "canvas": "347_478_1097_771",
    "defaultPlacement": "585_750_199_199",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1969",
      "1800",
      "1801",
      "1257",
      "1086"
    ]
  },
  "RSC103.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_DarkGreen_3.jpg?v=1753027837",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1578",
      "1103"
    ]
  },
  "FM25002-0200.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindPullM_PageantBlue-4.jpg?v=1757419740",
    "canvas": "897_958_157_128",
    "defaultPlacement": "921_969_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1360",
      "1801",
      "1118",
      "1800",
      "1242"
    ]
  },
  "FM26020-0002.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WBVest_Black-1.jpg?v=1773795160",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1199_748_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1955",
      "1800"
    ]
  },
  "FM26028-0002.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_CottonRangeHood-JB_1.jpg?v=1768675008",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1955",
      "1800"
    ]
  },
  "BP447.LowerPocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Seacrest-1.jpg?v=1760326674",
    "canvas": "550_1177_981_748",
    "defaultPlacement": "925_1464_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1246",
      "1800",
      "1118",
      "1975"
    ]
  },
  "UT254.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper3.0_MidGray-4.jpg?v=1749246983",
    "canvas": "364_453_1097_771",
    "defaultPlacement": "604_744_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1380",
      "1801",
      "1116",
      "1640"
    ]
  },
  "BP431.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_DarkGreenNavy_1.jpg?v=1736287319",
    "canvas": "581_1245_839_598",
    "defaultPlacement": "914_1453_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1390",
      "1118",
      "1800",
      "1243"
    ]
  },
  "DF230.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_2e02ce54-5857-428f-bb53-b49666749298.jpg?v=1735353672",
    "canvas": "859_896_360_360",
    "defaultPlacement": "879_916_333_333",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1116",
      "1578"
    ]
  },
  "GJ108.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_NavyWhiteRed_1.jpg?v=1736533779",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_749_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1147",
      "1118",
      "1640",
      "1243"
    ]
  },
  "TL109.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_ae8d04bd-1be1-40e3-bffa-fea0aed72f13.jpg?v=1735361635",
    "canvas": "515_1430_895_604",
    "defaultPlacement": "656_1787_108_108",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "FM25001-0002.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_WindblockerJB_1.jpg?v=1768675014",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1955",
      "1800"
    ]
  },
  "GR113.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_8f23eb27-f188-425e-97fe-870d0f9c7b3b.jpg?v=1735353533",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "829_960_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "RNS101.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_BlackWheat_1.jpg?v=1736282550",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_801_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 4,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1225",
      "1673"
    ]
  },
  "UT234.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_152a7512-27db-4467-9c76-e04bd9636b47.png?v=1735353612",
    "canvas": "1216_1212_229_314",
    "defaultPlacement": "955_1265_175_175",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1904",
      "1640",
      "1801",
      "1086"
    ]
  },
  "TL112.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_96073d94-8a28-41e2-b2ff-2c9361639fd4.jpg?v=1735361630",
    "canvas": "515_1430_895_604",
    "defaultPlacement": "655_1781_108_108",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1904",
      "1640",
      "1801",
      "1086"
    ]
  },
  "RNS206.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_OliveNightBone-1_6889d209-2c77-4a9e-ac40-d431d2d74b57.jpg?v=1760326225",
    "canvas": "231_586_887_593",
    "defaultPlacement": "615_820_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1871",
      "1118",
      "1800",
      "1795"
    ]
  },
  "UT404.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_MoonGray-3.jpg?v=1760378149",
    "canvas": "299_476_1385_778",
    "defaultPlacement": "705_811_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "GJ143.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Moss_1.jpg?v=1736375479",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_749_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1856",
      "1648"
    ]
  },
  "UT240.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_FieldKhaki_1.jpg?v=1736529868",
    "canvas": "351_474_1097_771",
    "defaultPlacement": "616_765_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1082"
    ]
  },
  "JT106.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_EssToteBack_MG.jpg?v=1744901170",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "890_1241_258_258",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "JT201.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_bd892428-85a8-471f-80ff-1aa990c2478b.jpg?v=1735361657",
    "canvas": "501_923_1018_827",
    "defaultPlacement": "900_1143_228_228",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1856",
      "1648"
    ]
  },
  "GJ147.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_PHC_Original_Espresso2-1.jpg?v=1748399628",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1120_610_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1072",
      "1257",
      "1130"
    ]
  },
  "BP441.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_NavyRS-1.jpg?v=1755256650",
    "canvas": "651_360_736_448",
    "defaultPlacement": "939_538_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "CS301.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/ClassicStand_RedPinstripe_2.jpg?v=1736534269",
    "canvas": "943_773_470_207",
    "defaultPlacement": "1085_793_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1147",
      "1800",
      "1640",
      "1118",
      "1801"
    ]
  },
  "CS103.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_c0cc8b7c-4a58-4f01-be23-dcb5f7fde98d.jpg?v=1735353418",
    "canvas": "943_773_470_207",
    "defaultPlacement": "1085_793_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "GR245.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Ecru-1.jpg?v=1774742220",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "795_968_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1255",
      "1622"
    ]
  },
  "PS204.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_a1b23dcb-ca18-46ce-b910-a42dff274c70.jpg?v=1735353511",
    "canvas": "1240_717_300_240",
    "defaultPlacement": "1311_757_128_128",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1243",
      "1640",
      "1118",
      "1934",
      "1801"
    ]
  },
  "RSC203.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_Olive-4.jpg?v=1749676808",
    "canvas": "231_586_887_593",
    "defaultPlacement": "605_795_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1359",
      "1801",
      "1147",
      "1969"
    ]
  },
  "HD113.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Goodie-Bag-BurntClay-4.jpg?v=1729890427",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "833_1050_397_397",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1084",
      "1648",
      "1899"
    ]
  },
  "DF202-1.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_Charcoal_1.jpg?v=1736356205",
    "canvas": "850_950_400_400",
    "defaultPlacement": "938_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1147",
      "1934",
      "1640"
    ]
  },
  "HD101.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_c5510220-e102-405e-8534-e857e3ca718d.jpg?v=1735353454",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "836_1007_392_392",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "UT406.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Black-5.jpg?v=1760378340",
    "canvas": "978_996_723_758",
    "defaultPlacement": "1275_1285_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "CS103.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_052a85db-efeb-45b8-82ca-6e3a24b40bb1.jpg?v=1735353417",
    "canvas": "601_735_470_192",
    "defaultPlacement": "782_755_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "GJ143.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Moss_3.jpg?v=1736375479",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1030_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1856",
      "1648"
    ]
  },
  "UTJ202.Left Side": {
    "location": "Left Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JuniorTrouper_DarkGreen_4.jpg?v=1739661973",
    "canvas": "1145_819_400_400",
    "defaultPlacement": "1275_929_160_160",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1578",
      "1103"
    ]
  },
  "UT234.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_0d092cd9-ab2b-44d3-919c-daade6373f56.png?v=1735353614",
    "canvas": "1193_758_305_238",
    "defaultPlacement": "1253_767_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1904",
      "1640",
      "1801",
      "1086"
    ]
  },
  "RNS104.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_BlackSageLeaf_2.jpg?v=1736282122",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_799_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1116",
      "1578"
    ]
  },
  "RNS207.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Ecola-2.jpg?v=1765334578",
    "canvas": "1080_620_554_550",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1795",
      "1146",
      "1640",
      "1086"
    ]
  },
  "PS202.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_06a7aef7-1bf8-4ebe-8b44-f6cd1f965eb2.png?v=1735353508",
    "canvas": "1299_761_145_145",
    "defaultPlacement": "1309_771_129_129",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1969",
      "1800"
    ]
  },
  "UTF305.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Backside_eba5bdd5-0c7f-4d08-ba2f-beb15ea70819.jpg?v=1735361628",
    "canvas": "450_823_1216_980",
    "defaultPlacement": "930_1310_252_252",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "CS303.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Pinstripe-Zepto-7_b2cb1d29-8c8f-41f0-b456-bf1d8ee94fb8.png?v=1734749067",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "708_1251_169_169",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "RNS202.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_BW-6_25f0500e-bfc4-427f-b0c2-a68a016d6da3.jpg?v=1749248215",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "UT250.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper3.0_NavyRip-5_2d054909-3466-4dc8-972e-4a176191d5ef.jpg?v=1749247169",
    "canvas": "1005_590_714_554",
    "defaultPlacement": "1272_778_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "GR230.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Rangefinder_Olive_Front.jpg?v=1749815672",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "836_870_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1856",
      "1969"
    ]
  },
  "BP424.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_FieldKhakiCharcoal_1.jpg?v=1736288565",
    "canvas": "677_418_690_336",
    "defaultPlacement": "928_549_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1041",
      "1801",
      "1640",
      "1082"
    ]
  },
  "BP445.LowerPocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Fescue-1.jpg?v=1760325417",
    "canvas": "550_1177_981_748",
    "defaultPlacement": "925_1470_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1822",
      "1969",
      "1801",
      "1255"
    ]
  },
  "RNS209.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_CedarFescue-2.jpg?v=1760325415",
    "canvas": "980_620_720_700",
    "defaultPlacement": "1270_840_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1822",
      "1255",
      "1801",
      "1559"
    ]
  },
  "CS100-Center": {
    "location": "Center",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/ClassicStand_Black_1001.png?v=1734439920",
    "canvas": "1100_591_650_300",
    "defaultPlacement": "831_1178_173_173",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "GR221.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_35d0118f-bb7a-40f5-88a7-d4f429525325.jpg?v=1735353528",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "792_973_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1977",
      "1990",
      "1024",
      "1800"
    ]
  },
  "HD113.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Goodie-Bag-BurntClay-4_f9ab220b-b50e-483c-b26b-efc58303a08a.jpg?v=1772583517",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "833_1050_397_397",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1648",
      "1899"
    ]
  },
  "DF216-1.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_891f0647-0902-448b-a4d8-4c8fc63b318a.jpg?v=1735353669",
    "canvas": "840_837_425_425",
    "defaultPlacement": "860_857_398_398",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1934",
      "1137",
      "1640"
    ]
  },
  "BP204.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_b33af1b3-9f08-4842-bd2d-4c0e56ef75bd.jpg?v=1735353246",
    "canvas": "795_936_456_441",
    "defaultPlacement": "872_1012_290_290",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "BP445.UnderFlap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Fescue-2.jpg?v=1760325417",
    "canvas": "625_510_799_536",
    "defaultPlacement": "929_670_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1255",
      "1801",
      "1640",
      "1822"
    ]
  },
  "UTWD403.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_WeekenderDuff_SteelBlue_3-1.jpg?v=1749745810",
    "canvas": "505_815_1037_688",
    "defaultPlacement": "912_1045_230_230",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1082",
      "1175"
    ]
  },
  "BP424.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_FieldKhakiCharcoal_1.jpg?v=1736288565",
    "canvas": "573_1267_881_530",
    "defaultPlacement": "912_1453_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1082",
      "1640",
      "1041"
    ]
  },
  "UT235.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_ba28a2cf-404b-4fcf-ae10-02c5af30a94b.png?v=1735353600",
    "canvas": "1216_1212_229_314",
    "defaultPlacement": "1228_1265_199_199",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1116",
      "1578"
    ]
  },
  "UT237.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Navy900d_1.jpg?v=1736529733",
    "canvas": "331_456_1097_771",
    "defaultPlacement": "610_747_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "RNS106.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_FieldKhakiCharcoal_1.jpg?v=1736281788",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_800_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1082",
      "1801",
      "1578",
      "1041"
    ]
  },
  "PS205.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_b9c63693-ef8f-4045-b4cb-57900bd64c2c.jpg?v=1735353513",
    "canvas": "1100_730_600_240",
    "defaultPlacement": "1323_807_130_130",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1969",
      "1800",
      "1118",
      "1856",
      "1801"
    ]
  },
  "FM25005-0401.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodie_Sand-3_c082fe9d-42c0-4673-80bc-d001903f0d97.jpg?v=1773878906",
    "canvas": "920_637_157_128",
    "defaultPlacement": "925_648_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1970",
      "1955",
      "1568"
    ]
  },
  "SB120.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ShoeBag_Graystone-1.jpg?v=1760325415",
    "canvas": "767_898_474_453",
    "defaultPlacement": "878_965_309_309",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1668",
      "1041"
    ]
  },
  "DF222.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_JetBlack_1.jpg?v=1736356205",
    "canvas": "918_1027_265_265",
    "defaultPlacement": "938_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1147",
      "1800"
    ]
  },
  "DF228.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_8c642887-da38-48a5-8e3d-b19d3afbccbb.jpg?v=1735353675",
    "canvas": "777_918_370_370",
    "defaultPlacement": "797_938_345_345",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1977",
      "1990",
      "1024",
      "1800"
    ]
  },
  "PS210.LeftSide": {
    "location": "Left Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_PS2048_NavyKodiak-4.jpg?v=1768934531",
    "canvas": "1037_648_630_375",
    "defaultPlacement": "1313_759_116_116",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1118",
      "1243"
    ]
  },
  "TX107.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Pageant-2.jpg?v=1768602695",
    "canvas": "964_588_829_592",
    "defaultPlacement": "1287_791_185_185",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1146",
      "1118",
      "1640",
      "1242"
    ]
  },
  "BP414-1.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_Black_1.jpg?v=1736288039",
    "canvas": "640_418_700_400",
    "defaultPlacement": "942_572_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "DK405.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_d8d6b683-524f-4c0a-8265-40381a8e613c.jpg?v=1735361658",
    "canvas": "790_700_360_360",
    "defaultPlacement": "826_743_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1648",
      "1899"
    ]
  },
  "SCB101.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ShortCourse_Navy-5_31857322-cb3a-47ee-aff8-0fdeaa65a510.jpg?v=1749656930",
    "canvas": "957_1024_683_688",
    "defaultPlacement": "1225_1265_155_155",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "GR231.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Alpine-1.jpg?v=1749558216",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "825_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1177",
      "1801"
    ]
  },
  "HD107.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_c6553934-3886-4fd1-80f6-b3f18e2d74f3.jpg?v=1735353457",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "819_1049_400_400",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1098",
      "1082",
      "1969"
    ]
  },
  "RD211.UpperBelly": {
    "location": "Upper Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Rider_Sonoma.jpg?v=1776256434",
    "canvas": "419_422_1214_1363",
    "defaultPlacement": "939_799_170_170",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1934",
      "1784"
    ]
  },
  "UT227-4.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper-R-White-5.jpg?v=1744674553",
    "canvas": "1193_1100_380_280",
    "defaultPlacement": "1253_1130_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "RD210.MiddleBelly": {
    "location": "Middle Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Rider_LeCreme-2_06fc8cea-b020-467b-8521-73a79ba842a2.jpg?v=1758715114",
    "canvas": "416_480_1214_1363",
    "defaultPlacement": "948_1062_170_170",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1147",
      "1072"
    ]
  },
  "SB116.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_59e564ae-ed7a-4c09-9c87-bd95e0a4d8f9.jpg?v=1735353404",
    "canvas": "780_900_450_450",
    "defaultPlacement": "855_956_335_335",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1051",
      "1640"
    ]
  },
  "SD102.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JonesSportsCo_2025_ScoutDuffleCharcoal_2-1.jpg?v=1743792564",
    "canvas": "495_740_1057_737",
    "defaultPlacement": "930_1029_225_225",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "UT249.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_MoonGray-Sienna_1.jpg?v=1736533670",
    "canvas": "347_478_1097_771",
    "defaultPlacement": "585_750_199_199",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1257",
      "1800",
      "1801",
      "1969",
      "1086"
    ]
  },
  "TX104.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Bone-1.jpg?v=1760524555",
    "canvas": "168_476_1400_830",
    "defaultPlacement": "560_834_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1255",
      "1041",
      "1801",
      "1822"
    ]
  },
  "UTC301.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_dfe3d710-2c95-4479-8217-e0081f088694.jpg?v=1735353643",
    "canvas": "259_402_1554_1460",
    "defaultPlacement": "827_927_421_421",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "BP440.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_MoonGrayRS-1-2.jpg?v=1764105948",
    "canvas": "621_357_805_519",
    "defaultPlacement": "941_535_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1274",
      "1086"
    ]
  },
  "DK414.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Dopp_Graystone-1.jpg?v=1760327227",
    "canvas": "450_541_1077_769",
    "defaultPlacement": "857_791_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1668",
      "1041"
    ]
  },
  "SD102.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JonesSportsCo_2025_ScoutDuffleCharcoal_1-1.jpg?v=1743792575",
    "canvas": "495_740_1057_737",
    "defaultPlacement": "920_1104_225_225",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "RSC203.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_Olive-5.jpg?v=1749676808",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_810_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1359",
      "1801",
      "1147",
      "1969"
    ]
  },
  "UT407.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_OliveNight-4.jpg?v=1760378275",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1242_833_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1871",
      "1118",
      "1640",
      "1795"
    ]
  },
  "SB104.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_f854fea9-6008-4ef8-b3a9-0200fd4d5b4d.jpg?v=1735353410",
    "canvas": "780_900_450_450",
    "defaultPlacement": "857_934_326_326",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1858",
      "1147"
    ]
  },
  "UT251.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper3.0_Azure-5.jpg?v=1749247045",
    "canvas": "1006_552_714_554",
    "defaultPlacement": "1275_740_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1082",
      "1801",
      "1640",
      "1175"
    ]
  },
  "UT232.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_d414daa7-35f9-4713-b0d3-11760db8d233.jpg?v=1735353607",
    "canvas": "1193_758_305_238",
    "defaultPlacement": "1253_767_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "DF404.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/ClubhouseDuffle-Onyx-2.jpg?v=1760367455",
    "canvas": "643_906_826_583",
    "defaultPlacement": "935_1040_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "PS204.LeftApparelPocket": {
    "location": "Left Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Jones-Players-Series-Navy-R-3_5a832c8e-d30a-4763-91db-ca2eb10a71b0.jpg?v=1734748824",
    "canvas": "989_968_636_458",
    "defaultPlacement": "1250_1150_128_128",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1934",
      "1243"
    ]
  },
  "PS211.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_PlayersSeries_DarkGreen-6_1.jpg?v=1775492614",
    "canvas": "1037_648_630_375",
    "defaultPlacement": "1290_785_130_130",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1118",
      "1390"
    ]
  },
  "BP603.FrontPocket": {
    "location": "Front Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityBackpackNatural1_a6ae3442-dad3-4bbd-805d-20932f5cced7.jpg?v=1734748395",
    "canvas": "611_1102_862_711",
    "defaultPlacement": "890_1275_270_270",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1856",
      "1648",
      "1084"
    ]
  },
  "RNS111.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_OliveLeCreme_1.jpg?v=1736282596",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1072",
      "1056",
      "1801",
      "1969"
    ]
  },
  "BP203.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_377206b6-4a38-4c63-b729-512a5537a80c.jpg?v=1735360475",
    "canvas": "817_901_456_441",
    "defaultPlacement": "901_979_289_289",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1934",
      "1118",
      "1640"
    ]
  },
  "SB106.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_9805b40e-61be-4c14-b9d7-789c153bbcee.jpg?v=1735353411",
    "canvas": "776_866_508_473",
    "defaultPlacement": "871_938_320_320",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1969",
      "1801"
    ]
  },
  "UT227-4.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper-R-White-4.jpg?v=1744674585",
    "canvas": "890_1212_250_330",
    "defaultPlacement": "915_1265_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "DF223.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_ce594be3-5db5-47f9-9834-580b6cdf225e.jpg?v=1735353660",
    "canvas": "720_780_600_600",
    "defaultPlacement": "849_912_326_326",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1578",
      "1103"
    ]
  },
  "RD209.Middle Belly": {
    "location": "Middle Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Sienna_Rider.jpg?v=1776255922",
    "canvas": "610_839_897_676",
    "defaultPlacement": "960_1088_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1138",
      "1112",
      "1225"
    ]
  },
  "RB138.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Charcoal_1.jpg?v=1736533850",
    "canvas": "492_449_1053_949",
    "defaultPlacement": "820_725_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1147",
      "1640"
    ]
  },
  "FM25007-0900.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindBlockerM_Blackwatch-4.jpg?v=1757419695",
    "canvas": "973_651_157_128",
    "defaultPlacement": "997_660_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1390",
      "1243",
      "1118",
      "1800"
    ]
  },
  "DK413.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Dopp_Ecru-1.jpg?v=1768524834",
    "canvas": "450_541_1077_769",
    "defaultPlacement": "845_776_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1255",
      "1622"
    ]
  },
  "BP442.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_CharcoalRS-1.jpg?v=1755256582",
    "canvas": "578_1257_891_620",
    "defaultPlacement": "919_1488_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1147",
      "1801",
      "1118",
      "1640"
    ]
  },
  "RNS207.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Ecola-3.jpg?v=1765334578",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1795",
      "1146",
      "1640",
      "1086"
    ]
  },
  "UT406.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Black-4.jpg?v=1760377780",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1242_833_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "RSC105.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_Splatter_2.jpg?v=1736282444",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1977",
      "1990",
      "1024",
      "1800"
    ]
  },
  "GR223.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_SoftBlueRed_2.jpg?v=1737046184",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "802_948_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1243",
      "1147",
      "1801",
      "1640",
      "1953"
    ]
  },
  "RNS110.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CorduraCamo_3.jpg?v=1753027719",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "RNS106.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_FieldKhakiCharcoal_3.jpg?v=1753027435",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1082",
      "1801",
      "1578",
      "1041"
    ]
  },
  "DF208-1.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_b13ef8cc-1a74-4e67-9f4e-b9b8d0c0872b.jpg?v=1735353652",
    "canvas": "771_929_370_370",
    "defaultPlacement": "791_949_344_344",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1934",
      "1800"
    ]
  },
  "BP444.UnderFlap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_OliveNight-Bone-2.jpg?v=1760325418",
    "canvas": "625_510_799_536",
    "defaultPlacement": "933_700_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1801",
      "1640",
      "1795"
    ]
  },
  "FM26021-0101.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodieLite_Bone-4.jpg?v=1773873297",
    "canvas": "1024_592_120_120",
    "defaultPlacement": "1024_592_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1118",
      "1902",
      "1955",
      "1071"
    ]
  },
  "HW203.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Handwarmer_Charc-1.jpg?v=1749557877",
    "canvas": "495_836_1057_737",
    "defaultPlacement": "890_1085_285_285",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1934",
      "1640"
    ]
  },
  "GR118.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_Black_2.jpg?v=1737046184",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "785_919_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "FM26001-0200.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_FTQZ_PB-1.jpg?v=1773794726",
    "canvas": "1232_509_120_120",
    "defaultPlacement": "1232_509_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1147",
      "1242"
    ]
  },
  "RSC202.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_Black-4.jpg?v=1753025945",
    "canvas": "231_586_887_593",
    "defaultPlacement": "635_830_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "DK303.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_1a3d33be-ea0b-4c69-a975-86e3aaf01269.jpg?v=1735353433",
    "canvas": "820_790_330_330",
    "defaultPlacement": "851_828_281_281",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1801",
      "1904",
      "1086"
    ]
  },
  "UT411.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Bone-5.jpg?v=1760378307",
    "canvas": "1008_975_725_768",
    "defaultPlacement": "1290_1265_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1919",
      "1801",
      "1640",
      "1822"
    ]
  },
  "DF217.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_Gray_1.jpg?v=1736356205",
    "canvas": "918_1027_265_265",
    "defaultPlacement": "938_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1851",
      "1086"
    ]
  },
  "UTJ203.Left Side": {
    "location": "Left Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JuniorTrouper_MoonGray_4.jpg?v=1739661789",
    "canvas": "1145_819_400_400",
    "defaultPlacement": "1275_929_160_160",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "GR238.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Cedar-2.jpg?v=1760326894",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1255",
      "1801",
      "1559"
    ]
  },
  "DF225.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_e81f00ab-55bd-4148-8ac0-08e3a289fe24.jpg?v=1735353666",
    "canvas": "811_866_360_360",
    "defaultPlacement": "831_886_337_337",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1934",
      "1243"
    ]
  },
  "BP501.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_9fcd969b-1a24-4a12-8208-c9aa31b9fa03.jpg?v=1735353503",
    "canvas": "985_641_250_250",
    "defaultPlacement": "1005_671_200_200",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "UTWD401.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_WeekenderDuff_Black_3-1-1.jpg?v=1749745810",
    "canvas": "470_930_1037_688",
    "defaultPlacement": "890_1160_230_230",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1147",
      "1800"
    ]
  },
  "DF203-1.End-Cap": {
    "location": "End-Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End-Cap.jpg?v=1735353667",
    "canvas": "823_897_350_350",
    "defaultPlacement": "843_917_326_326",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "ZP301.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_ee6b3944-ff89-4067-be9a-c9dca5a234ab.jpg?v=1735353449",
    "canvas": "893_915_300_330",
    "defaultPlacement": "893_915_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1118",
      "1673"
    ]
  },
  "DK406.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_7dc5a702-7c00-4ec5-b87b-c92880f40835.jpg?v=1735361661",
    "canvas": "740_740_450_450",
    "defaultPlacement": "819_771_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1856",
      "1648",
      "1084"
    ]
  },
  "UT404.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_MoonGray-5.jpg?v=1760378149",
    "canvas": "978_996_723_758",
    "defaultPlacement": "1259_1250_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "BP418.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_LeCremeOlive_2.jpg?v=1736288227",
    "canvas": "625_510_799_536",
    "defaultPlacement": "918_707_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1969",
      "1056",
      "1801",
      "1072"
    ]
  },
  "UT412.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Cedar-4.jpg?v=1760378183",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1242_833_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1255",
      "1801",
      "1559"
    ]
  },
  "RNS204.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_SoftBlue-Navy_3_9408970e-b2c4-4400-a581-58632c401e10.jpg?v=1755377978",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "DK407.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_b80cb9bd-351e-4fae-aec1-b86ccf15e3b5.jpg?v=1735361568",
    "canvas": "790_855_360_360",
    "defaultPlacement": "817_879_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1640",
      "1390"
    ]
  },
  "HD112.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_3ca335e7-0c2b-46b2-aa5f-c30c89aeb8fd.jpg?v=1735361681",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "833_1050_397_397",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1856",
      "1648"
    ]
  },
  "HB104.Top": {
    "location": "Top",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Top.jpg?v=1735353459",
    "canvas": "854_848_430_430",
    "defaultPlacement": "884_878_370_370",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1138",
      "1112",
      "1225"
    ]
  },
  "GR209.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_b3448198-108a-477e-adba-1e77512c9d65.jpg?v=1735353518",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "BP602.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_4a90451c-8602-405c-af72-cc7b91a8d4f1.jpg?v=1735361653",
    "canvas": "612_251_797_711",
    "defaultPlacement": "902_395_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1648",
      "1899"
    ]
  },
  "UT240.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_FieldKhaki_2.jpg?v=1736529868",
    "canvas": "985_605_714_554",
    "defaultPlacement": "1253_793_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1082"
    ]
  },
  "FM26033-0901.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_WindblockerTartan_1.jpg?v=1768675013",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1567",
      "1800",
      "1156",
      "1953",
      "1792"
    ]
  },
  "RB131.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Sonoma_2.jpg?v=1737046137",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1118",
      "1784"
    ]
  },
  "GR220.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_3ffd3293-bd67-4cdc-a2bb-7e3fba12f520.jpg?v=1735353523",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "785_948_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1082",
      "1800",
      "1801",
      "1640",
      "1243"
    ]
  },
  "CS106.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/ClassicStand_White_2.jpg?v=1736534275",
    "canvas": "943_773_470_207",
    "defaultPlacement": "1085_793_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1051",
      "1801"
    ]
  },
  "BP117.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_0dcee23f-de94-4a3f-8a8a-8216181a5fb1.jpg?v=1735353645",
    "canvas": "612_251_797_711",
    "defaultPlacement": "917_395_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "SCB102.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ShortCourse_DarkGreen-4.jpg?v=1749246759",
    "canvas": "998_634_728_466",
    "defaultPlacement": "1285_815_155_155",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1578",
      "1103"
    ]
  },
  "GJ103.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Navy_3.jpg?v=1736374957",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1074_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "BP414-1.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_Black_1.jpg?v=1736288039",
    "canvas": "566_1231_905_631",
    "defaultPlacement": "919_1453_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "RB132.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_MoonGray_1.jpg?v=1736533849",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "GJ129.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Bomber_1.jpg?v=1736374087",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_749_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "GJ147.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_PHC_Original_Espresso3-1.jpg?v=1748399628",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_790_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1072",
      "1257",
      "1130"
    ]
  },
  "GD106.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/GoodieBagR_Canvas2.jpg?v=1741724759",
    "canvas": "795_1030_480_480",
    "defaultPlacement": "819_1068_400_400",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1243",
      "1801",
      "1640",
      "1800",
      "1072"
    ]
  },
  "RSC204.Front": {
    "location": "Front",
    "picture": "",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "FM26029-0101.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_CottonRangeCrew-Bone_1.jpg?v=1768675008",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1801",
      "1567",
      "1072"
    ]
  },
  "FM25001-0302.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_WindblockerLoden_1.jpg?v=1768675014",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1955",
      "1156"
    ]
  },
  "GR222.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_Kodiak_2.jpg?v=1737046185",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "792_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "BP111.FrontPocket": {
    "location": "Front Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JonesClassicBackpackNavy.jpg?v=1743723732",
    "canvas": "611_1102_862_711",
    "defaultPlacement": "907_1300_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1640",
      "1243"
    ]
  },
  "UT412.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Cedar-5.jpg?v=1760378183",
    "canvas": "1008_975_725_768",
    "defaultPlacement": "1276_1265_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1255",
      "1801",
      "1559"
    ]
  },
  "SCB102.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ShortCourse_DarkGreen-5.jpg?v=1749246759",
    "canvas": "957_1024_683_688",
    "defaultPlacement": "1165_1265_155_155",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1578",
      "1103"
    ]
  },
  "GR303.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrunkCaddy_DarkGreen-1.jpg?v=1749246924",
    "canvas": "480_777_1087_887",
    "defaultPlacement": "881_1050_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1955",
      "1390"
    ]
  },
  "UT249.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_MoonGray-Sienna_3.jpg?v=1736533670",
    "canvas": "978_974_725_768",
    "defaultPlacement": "1246_1264_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1257",
      "1800",
      "1801",
      "1969",
      "1086"
    ]
  },
  "RB103.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Navy_3.jpg?v=1772473880",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "820_730_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "RD210.UpperBelly": {
    "location": "Upper Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Rider_LeCreme-2_06fc8cea-b020-467b-8521-73a79ba842a2.jpg?v=1758715114",
    "canvas": "416_480_1214_1363",
    "defaultPlacement": "948_800_170_170",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1147",
      "1072"
    ]
  },
  "UT240.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_FieldKhaki_3.jpg?v=1736529867",
    "canvas": "987_974_725_768",
    "defaultPlacement": "1255_1264_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1082"
    ]
  },
  "GR207.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_18c01ac6-7a41-4ed4-a15a-e1659a1c9a8d.jpg?v=1735353521",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "809_978_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "FM26004-0400.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_PRJBrown_1_28402377-118e-41a2-9332-f92ed8dc3888.jpg?v=1767462706",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1336",
      "1955",
      "1801",
      "1118",
      "1800"
    ]
  },
  "UT406.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Black-3.jpg?v=1760378340",
    "canvas": "253_498_1385_778",
    "defaultPlacement": "660_820_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "SCB102.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ShortCourse_DarkGreen-3.jpg?v=1749246760",
    "canvas": "330_612_937_519",
    "defaultPlacement": "645_820_150_150",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1578",
      "1103"
    ]
  },
  "FM25002-0401.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindPullM_Sand-4.jpg?v=1757419740",
    "canvas": "881_932_157_128",
    "defaultPlacement": "905_941_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1970",
      "1955",
      "1568"
    ]
  },
  "BP428.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_SoftBlueNavy_1.jpg?v=1736288370",
    "canvas": "650_423_764_534",
    "defaultPlacement": "950_570_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1243",
      "1147",
      "1801",
      "1640",
      "1953"
    ]
  },
  "RNS109.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CharcoalBlackRed_3.jpg?v=1753027910",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1147",
      "1118",
      "1800"
    ]
  },
  "UTWD302.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_38d4fbe9-3865-462d-b304-687c251fe302.jpg?v=1735353444",
    "canvas": "900_1025_250_250",
    "defaultPlacement": "938_1035_215_215",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1858",
      "1243"
    ]
  },
  "FM26033-0200.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_RangeQuarter-PB_1.jpg?v=1768675010",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1041",
      "1800",
      "1567",
      "1242"
    ]
  },
  "BP431.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_DarkGreenNavy_1.jpg?v=1736287319",
    "canvas": "609_387_804_503",
    "defaultPlacement": "928_522_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1243",
      "1800",
      "1118",
      "1390"
    ]
  },
  "RSC107.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_Black_2.jpg?v=1736282712",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_810_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "UT417.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Ecru-5.jpg?v=1771866505",
    "canvas": "865_996_723_758",
    "defaultPlacement": "1300_1285_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1255",
      "1622"
    ]
  },
  "GR212.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_BlackRed_2.jpg?v=1737046184",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "776_938_430_430",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1147",
      "1801",
      "1118",
      "1858",
      "1800"
    ]
  },
  "DF601.Top": {
    "location": "Top",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ScoutDuff_Black-3.jpg?v=1760377782",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "___",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1147",
      "1800"
    ]
  },
  "JT116.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_EssToteBack_Canv.jpg?v=1744901170",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "868_1181_251_251",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1969",
      "1336",
      "1072"
    ]
  },
  "FM26001-0002.LeftChest": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_FTQZ_BG-1.jpg?v=1773794911",
    "canvas": "1172_577_120_120",
    "defaultPlacement": "1172_577_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1041",
      "1801",
      "1640",
      "1147",
      "1800"
    ]
  },
  "GR228.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Oxford-1.jpg?v=1749558163",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "805_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1800",
      "1243"
    ]
  },
  "RD203.MiddleBelly": {
    "location": "Middle Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Belly_d0642cdb-f9b8-4cf2-b9d6-3b4b83aef05c.jpg?v=1735361609",
    "canvas": "610_839_897_676",
    "defaultPlacement": "960_1088_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1147",
      "1118",
      "1640",
      "1243"
    ]
  },
  "FM25004-0400.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_FleeceVestTimber_1.jpg?v=1768675008",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1144",
      "1801",
      "1659",
      "1118",
      "1800"
    ]
  },
  "RB129.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_ClayGreen_3.jpg?v=1737046138",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1116",
      "1098"
    ]
  },
  "RSC202.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_Black-6.jpg?v=1753025945",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "GR227.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_MoonGray_2.jpg?v=1737046184",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "824_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "GR241.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Seacrest-1.jpg?v=1760327012",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1975",
      "1801",
      "1800",
      "1118",
      "1246"
    ]
  },
  "RHT101.RightSide": {
    "location": "Right Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_StormTowel_2048-4.jpg?v=1767977709",
    "canvas": "1000_563_541_340",
    "defaultPlacement": "1147_668_145_145",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "BP418.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_LeCremeOlive_1.jpg?v=1736288227",
    "canvas": "573_1267_881_530",
    "defaultPlacement": "906_1453_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1072",
      "1056",
      "1801",
      "1969"
    ]
  },
  "FM26001-0101.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_FTQZ_Bone-1.jpg?v=1773794825",
    "canvas": "1205_583_120_120",
    "defaultPlacement": "1205_583_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1970",
      "1955",
      "1072"
    ]
  },
  "TX107.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Pageant-1.jpg?v=1768602695",
    "canvas": "204_498_1264_684",
    "defaultPlacement": "544_768_185_185",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1146",
      "1118",
      "1640",
      "1242"
    ]
  },
  "BP601.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_edf081a8-6027-4b8c-b494-29654a60e328.jpg?v=1735361656",
    "canvas": "612_251_797_711",
    "defaultPlacement": "885_423_269_269",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1856",
      "1648"
    ]
  },
  "JT103.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Essential_Tote_Clay_Green.jpg?v=1776167640",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "900_1247_255_255",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1116",
      "1098"
    ]
  },
  "RB101.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Black_3.jpg?v=1737046138",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "820_730_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1934",
      "1800"
    ]
  },
  "UT234.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper3.0MoonGrayFernRight_c87ba7ff-1fa2-48f1-a074-4111f3d1b565.png?v=1734748715",
    "canvas": "484_774_510_231",
    "defaultPlacement": "615_900_199_199",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1904",
      "1800",
      "1801",
      "1640",
      "1086"
    ]
  },
  "RB128.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Sienna_3.jpg?v=1737046138",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1138",
      "1112",
      "1225"
    ]
  },
  "FM26027-0002.BackLeftPocket": {
    "location": "Back Left Pocket",
    "picture": "",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "SWB103.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ScoutWeekenderBackpack_Charcoal.jpg?v=1745502631",
    "canvas": "868_898_427_408",
    "defaultPlacement": "965_990_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "DF216-1.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_b4e7e740-f180-49e6-b24c-0a3f6a5c5f0f.jpg?v=1735353669",
    "canvas": "918_1027_265_265",
    "defaultPlacement": "938_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1137",
      "1934"
    ]
  },
  "RNS201.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_DGNavy-5.jpg?v=1749586588",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1243",
      "1390"
    ]
  },
  "RB141.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_DarkGreen_3.jpg?v=1737046138",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1578",
      "1103"
    ]
  },
  "DK302.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_3cecb3a3-ae59-4598-a8b7-0e857433dc2f.jpg?v=1735353430",
    "canvas": "830_780_300_300",
    "defaultPlacement": "864_803_258_258",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1578",
      "1800"
    ]
  },
  "RB128.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Sienna_2.jpg?v=1737046138",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1138",
      "1112",
      "1225"
    ]
  },
  "FM25001-0402.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_WindblockerWheat_1.jpg?v=1768675014",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1156",
      "1792"
    ]
  },
  "RSC107.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_Black_1.jpg?v=1736282712",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "UT236.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Black_3.jpg?v=1736529495",
    "canvas": "994_975_725_768",
    "defaultPlacement": "1262_1265_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "DK403.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_aa342f69-adb5-415e-8356-b7520a6207d1.jpg?v=1735353427",
    "canvas": "795_810_330_330",
    "defaultPlacement": "831_846_279_279",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "GR241.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Seacrest-2.jpg?v=1760327012",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1975",
      "1801",
      "1800",
      "1118",
      "1246"
    ]
  },
  "RD205.UpperBelly": {
    "location": "Upper Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-White_9bfc6011-5883-4ab5-93bc-e1332621cb08.jpg?v=1734748355",
    "canvas": "610_559_897_676",
    "defaultPlacement": "914_797_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "BP414-1.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_Black_2.jpg?v=1736288039",
    "canvas": "625_510_799_536",
    "defaultPlacement": "896_698_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "UT409.Right": {
    "location": "Right",
    "picture": "",
    "canvas": "315_528_1255_629",
    "defaultPlacement": "595_779_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "BP431.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_DarkGreenNavy_2.jpg?v=1736287319",
    "canvas": "584_504_878_605",
    "defaultPlacement": "929_675_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1243",
      "1800",
      "1118",
      "1390"
    ]
  },
  "GJ108.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_NavyWhiteRed_2.jpg?v=1736533778",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_767_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1147",
      "1118",
      "1640",
      "1243"
    ]
  },
  "RD202.UpperBelly": {
    "location": "Upper Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Charcoal_f2b373fd-6322-47b7-b312-78d8362b6c68.jpg?v=1734748347",
    "canvas": "610_559_897_676",
    "defaultPlacement": "960_808_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1845",
      "1800"
    ]
  },
  "GJ142.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Camo_3.jpg?v=1736375291",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1065_635_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "DF229.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_3f7cab57-7a80-4dab-adf1-fec17d900914.jpg?v=1735353662",
    "canvas": "811_833_365_365",
    "defaultPlacement": "831_853_341_341",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1082"
    ]
  },
  "FM25005-0300.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodie_NS-4.jpg?v=1773795661",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "929_637_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1955"
    ]
  },
  "RD202.MiddleBelly": {
    "location": "Middle Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Belly_dabf7525-1764-4e50-9c87-ccfbca6f5aae.jpg?v=1735361610",
    "canvas": "610_839_897_676",
    "defaultPlacement": "960_1088_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1845",
      "1800"
    ]
  },
  "JT104.Back": {
    "location": "Back",
    "picture": "",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "883_1253_252_252",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "RD201.LowerBelly": {
    "location": "Lower Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Black_f7c34224-3adc-4776-a037-ac87c13ca725.jpg?v=1772474440",
    "canvas": "596_1142_897_676",
    "defaultPlacement": "970_1368_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1845",
      "1800"
    ]
  },
  "UT241.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_SageLeaf_3.jpg?v=1736529380",
    "canvas": "973_975_725_768",
    "defaultPlacement": "1241_1265_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1118",
      "1578"
    ]
  },
  "JT102.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_1c91d9b7-1ba2-49ed-99d8-fccd0352e9b6.png?v=1735353591",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "923_1247_255_255",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1138",
      "1112",
      "1225"
    ]
  },
  "FM25005-0104.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_RangeHoodie-Heather_1.jpg?v=1768675012",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1955",
      "1118"
    ]
  },
  "SB114.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back.jpg?v=1735353401",
    "canvas": "176_75_1695_1897",
    "defaultPlacement": "869_958_309_309",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "GJ144.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_BurntClay_3.jpg?v=1736375393",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1007_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1648",
      "1899"
    ]
  },
  "TX104.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Bone-3.jpg?v=1760524555",
    "canvas": "827_1025_757_819",
    "defaultPlacement": "1150_1355_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1255",
      "1801",
      "1041",
      "1822"
    ]
  },
  "UT248.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_MoonGray-Olive_3.jpg?v=1736533596",
    "canvas": "977_974_725_768",
    "defaultPlacement": "1243_1264_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1969",
      "1800",
      "1801",
      "1257",
      "1086"
    ]
  },
  "DF226.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_Wheat_1.jpg?v=1736356205",
    "canvas": "880_975_320_320",
    "defaultPlacement": "930_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1225",
      "1673"
    ]
  },
  "UT415.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_DarkGreen-4.jpg?v=1760378244",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1260_833_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1578",
      "1103"
    ]
  },
  "RD209.Lower Belly": {
    "location": "Lower Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Sienna_Rider.jpg?v=1776255922",
    "canvas": "596_1142_897_676",
    "defaultPlacement": "954_1368_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1138",
      "1112",
      "1225"
    ]
  },
  "CS301.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/ClassicStand_RedPinstripe_1.jpg?v=1748414113",
    "canvas": "601_735_470_192",
    "defaultPlacement": "782_755_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1147",
      "1800",
      "1640",
      "1118",
      "1801"
    ]
  },
  "GR232.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Onyx-1.jpg?v=1749558249",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "815_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "DF602.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ScoutMiniTour_Navy1.jpg?v=1769793739",
    "canvas": "469_901_1109_674",
    "defaultPlacement": "948_1122_225_225",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1800",
      "1375",
      "1243"
    ]
  },
  "RNS203.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_OliveLeCreme_2.jpg?v=1736282596",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1072",
      "1056",
      "1801",
      "1969"
    ]
  },
  "RB102.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Gray_2.jpg?v=1737046139",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "820_735_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1858",
      "1118"
    ]
  },
  "GJ101.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Black_3.jpg?v=1736374025",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1063_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "RNS201.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_DGNavy-6.jpg?v=1749586588",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1243",
      "1390"
    ]
  },
  "JT114.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_324b7ca0-0360-4b7c-8db4-b6c81b7e42c9.jpg?v=1735353585",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "900_1200_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1858",
      "1800"
    ]
  },
  "RNS110.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CorduraCamo_1.jpg?v=1736282839",
    "canvas": "231_586_887_593",
    "defaultPlacement": "598_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "SWB101.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/WSJ_Scout_Weekender_Backpack_Navy.jpg?v=1769605305",
    "canvas": "514_561_1019_1031",
    "defaultPlacement": "904_989_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1147",
      "1243"
    ]
  },
  "BP446.UpperPocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Graystone-1.jpg?v=1760325418",
    "canvas": "677_418_690_336",
    "defaultPlacement": "950_540_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1801",
      "1041"
    ]
  },
  "RSC105.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_Splatter_1.jpg?v=1736282444",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_809_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1977",
      "1990",
      "1024",
      "1800"
    ]
  },
  "BP421.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_CorduraCamo_2.jpg?v=1736288479",
    "canvas": "625_510_799_536",
    "defaultPlacement": "929_698_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "DF224.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_585fff09-78f4-4dca-835b-431e363d4596.jpg?v=1735353673",
    "canvas": "844_900_380_380",
    "defaultPlacement": "864_920_356_356",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1243",
      "1858"
    ]
  },
  "PS103.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_60b1501f-c0f0-46c9-b3eb-c4cea2aa073a.png?v=1735353510",
    "canvas": "1065_590_636_458",
    "defaultPlacement": "1319_792_116_116",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1138",
      "1118",
      "1274",
      "1243"
    ]
  },
  "UT249.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_MoonGray-Sienna_2.jpg?v=1736533670",
    "canvas": "988_606_714_554",
    "defaultPlacement": "1264_793_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1257",
      "1800",
      "1801",
      "1969",
      "1086"
    ]
  },
  "GJ136.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Charcoal_1.jpg?v=1736374140",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_749_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1640"
    ]
  },
  "RNS205.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Seacrest-3.jpg?v=1760326152",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1246",
      "1118",
      "1800",
      "1975"
    ]
  },
  "BP442.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_CharcoalRS-1.jpg?v=1755256582",
    "canvas": "630_369_787_480",
    "defaultPlacement": "941_527_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1147",
      "1801",
      "1118",
      "1640"
    ]
  },
  "GR115.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_Charcoal_2.jpg?v=1737046185",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "831_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "RNS207.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Ecola-1.jpg?v=1765334578",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1795",
      "1146",
      "1640",
      "1086"
    ]
  },
  "BP442.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_CharcoalRS-2.jpg?v=1755256635",
    "canvas": "561_459_891_620",
    "defaultPlacement": "919_649_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1147",
      "1801",
      "1118",
      "1640"
    ]
  },
  "GJ105.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Green_1.jpg?v=1736375090",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_749_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1051",
      "1851"
    ]
  },
  "BP444.LowerPocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_OliveNight-Bone-1.jpg?v=1760325418",
    "canvas": "550_1177_981_748",
    "defaultPlacement": "935_1464_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1801",
      "1640",
      "1795"
    ]
  },
  "RNS108.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CharcoalBlackWheat_3.jpg?v=1753027769",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1673",
      "1118",
      "1640"
    ]
  },
  "RSC207.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Graystone-3.jpg?v=1760326335",
    "canvas": "1024_1335_588_544",
    "defaultPlacement": "1238_1526_162_162",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1668",
      "1041"
    ]
  },
  "BP446.UnderFlap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Graystone-2.jpg?v=1760326640",
    "canvas": "625_510_799_536",
    "defaultPlacement": "934_670_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1801",
      "1041"
    ]
  },
  "RD206.UpperBelly": {
    "location": "Upper Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Navy1.jpg?v=1729181384",
    "canvas": "610_559_897_676",
    "defaultPlacement": "1001_808_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "RNS205.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Seacrest-1.jpg?v=1760326152",
    "canvas": "231_586_887_593",
    "defaultPlacement": "620_840_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1246",
      "1118",
      "1800",
      "1975"
    ]
  },
  "BP425.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_BlackSageLeaf_1.jpg?v=1736286754",
    "canvas": "677_418_690_400",
    "defaultPlacement": "934_566_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1138",
      "1578",
      "1801",
      "1640",
      "1800"
    ]
  },
  "UT237.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Navy900d_3.jpg?v=1736529733",
    "canvas": "988_974_725_768",
    "defaultPlacement": "1256_1264_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "HW102.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_9df59f03-ae24-43a9-a1bc-65a874dd671a.jpg?v=1735353437",
    "canvas": "875_923_300_300",
    "defaultPlacement": "875_923_285_285",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1934",
      "1800"
    ]
  },
  "UTWD303.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/WeekenderDuffle_Charcoal_2.jpg?v=1736353297",
    "canvas": "900_1080_250_250",
    "defaultPlacement": "940_1090_215_215",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1977",
      "1640"
    ]
  },
  "SB118.Back": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Backside.jpg?v=1735361400",
    "canvas": "176_75_1695_1897",
    "defaultPlacement": "860_975_319_319",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1640",
      "1390"
    ]
  },
  "PS201.LeftApparelPocket": {
    "location": "Left Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_PlayersSeries_Sonoma.jpg?v=1768943881",
    "canvas": "989_968_636_458",
    "defaultPlacement": "1240_1145_130_130",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1640",
      "1784"
    ]
  },
  "FM26021-0102.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodieLite_HG-3_11233a03-e499-405f-bbcf-e6f344286886.jpg?v=1773852474",
    "canvas": "920_637_157_128",
    "defaultPlacement": "920_648_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1955",
      "1041"
    ]
  },
  "RD210.LowerBelly": {
    "location": "Lower Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Rider_LeCreme-2_06fc8cea-b020-467b-8521-73a79ba842a2.jpg?v=1758715114",
    "canvas": "416_480_1214_1363",
    "defaultPlacement": "948_1326_170_170",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1147",
      "1072"
    ]
  },
  "UT250.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper3.0_NavyRip-4_f0a4916d-a724-4eb3-995c-83164fe2cac4.jpg?v=1749591906",
    "canvas": "355_450_1097_771",
    "defaultPlacement": "610_741_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "FM26001-0102.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_FTQZ_GB-1.jpg?v=1773794773",
    "canvas": "1198_588_120_120",
    "defaultPlacement": "1198_588_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1041",
      "1801",
      "1640",
      "1274",
      "1800"
    ]
  },
  "GJ146.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_HeritageGreen_1.jpg?v=1736375531",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_749_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1640",
      "1390"
    ]
  },
  "BP430.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_MoonGrayNavy_2.jpg?v=1736287567",
    "canvas": "557_479_905_631",
    "defaultPlacement": "929_695_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1118",
      "1243",
      "1801",
      "1086"
    ]
  },
  "RB143.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Ranger26_AllBlack-3.jpg?v=1767741037",
    "canvas": "492_449_1053_949",
    "defaultPlacement": "820_725_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "BP427.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_CementCobalt_1.jpg?v=1736288611",
    "canvas": "677_418_690_336",
    "defaultPlacement": "954_552_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1134",
      "1800",
      "1801",
      "1640",
      "1086"
    ]
  },
  "FM25005-0001.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodie_Black-3_33e21a3f-8497-415a-af8e-fca4d627dd74.jpg?v=1757419862",
    "canvas": "917_676_166_131",
    "defaultPlacement": "946_691_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1955",
      "1970",
      "1800"
    ]
  },
  "GR236.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Fescue-2.jpg?v=1760326808",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1559",
      "1801",
      "1255"
    ]
  },
  "RNS201.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_DGNavy-4.jpg?v=1749586588",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1243",
      "1390"
    ]
  },
  "GR231.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Alpine-2.jpg?v=1771248071",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "792_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1177",
      "1801"
    ]
  },
  "RD204.Lower Belly": {
    "location": "Lower Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Green.jpg?v=1739830674",
    "canvas": "596_1142_897_676",
    "defaultPlacement": "954_1368_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1051",
      "1851"
    ]
  },
  "GR302.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/TrunkCaddie_Black_2.jpg?v=1749812395",
    "canvas": "480_777_1087_887",
    "defaultPlacement": "895_1048_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1845",
      "1800"
    ]
  },
  "RD211.MiddleBelly": {
    "location": "Middle Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Rider_Sonoma.jpg?v=1776256434",
    "canvas": "419_422_1214_1363",
    "defaultPlacement": "939_1061_170_170",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1934",
      "1784"
    ]
  },
  "TL113.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_012ca79d-04d4-44d9-a442-163e80dbec87.jpg?v=1735361629",
    "canvas": "515_1430_895_604",
    "defaultPlacement": "673_1743_114_114",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "FM25007-0900.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindBlockerM_Blackwatch-1.jpg?v=1757419789",
    "canvas": "1116_651_157_1128",
    "defaultPlacement": "1118_660_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1390",
      "1243",
      "1118",
      "1800"
    ]
  },
  "DF218.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_Camo_1.jpg?v=1736356205",
    "canvas": "938_1027_265_265",
    "defaultPlacement": "938_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "GR242.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Durham-1.jpg?v=1760325417",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1987",
      "1800",
      "1801",
      "1934",
      "1118"
    ]
  },
  "DF227.End Cap": {
    "location": "End Cap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/End_Cap_4a8bf352-697b-4ea5-b0b6-59307da4616c.jpg?v=1735353655",
    "canvas": "680_800_600_600",
    "defaultPlacement": "784_873_368_368",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1243",
      "1977",
      "1640"
    ]
  },
  "RB101.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Black_2.jpg?v=1737046138",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "820_730_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1934",
      "1800"
    ]
  },
  "JT114.Back": {
    "location": "Back",
    "picture": "",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "900_1200_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1858",
      "1800"
    ]
  },
  "BP444.UpperPocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_OliveNight-Bone-1.jpg?v=1760325418",
    "canvas": "677_420_690_400",
    "defaultPlacement": "951_594_175_175",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1795",
      "1800",
      "1801",
      "1640",
      "1822"
    ]
  },
  "GR236.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Fescue-1.jpg?v=1760325417",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "830_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1559",
      "1801",
      "1255"
    ]
  },
  "UT238.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Charcoal_2.jpg?v=1736529430",
    "canvas": "1120_650_410_450",
    "defaultPlacement": "1257_803_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "FM26001-0200.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_FTQZ_PB-4.jpg?v=1773794725",
    "canvas": "997_769_120_120",
    "defaultPlacement": "997_769_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1147",
      "1242"
    ]
  },
  "RB129.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_ClayGreen_1.jpg?v=1736533849",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1116",
      "1098"
    ]
  },
  "RNS102.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_SoftBlue-Navy_2.jpg?v=1736281623",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1953",
      "1147",
      "1801",
      "1118",
      "1243"
    ]
  },
  "RB127.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_LeCreme_2.jpg?v=1737046137",
    "canvas": "850_762_460_460",
    "defaultPlacement": "860_772_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1072"
    ]
  },
  "UT244.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_BlackRed_2.jpg?v=1736533470",
    "canvas": "997_605_714_554",
    "defaultPlacement": "1264_793_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1147",
      "1801",
      "1118",
      "1858",
      "1800"
    ]
  },
  "HD104.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/GoodieBagR_Wheat2.jpg?v=1708715935",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "821_1068_397_397",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1663",
      "1969",
      "1670"
    ]
  },
  "BP419.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_BlackWheat_1.jpg?v=1736288670",
    "canvas": "677_418_690_400",
    "defaultPlacement": "923_565_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1673",
      "1118",
      "1640",
      "1800"
    ]
  },
  "RB131.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Sonoma_3.jpg?v=1737046138",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1118",
      "1784"
    ]
  },
  "RB116.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Ranger_Black-1_6b3aaf86-9eed-4679-af96-3826cab1cf5e.png?v=1762258091",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "830_730_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1858",
      "1800"
    ]
  },
  "BP448.LowerPocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Cedar-1.jpg?v=1760326551",
    "canvas": "550_1177_981_748",
    "defaultPlacement": "945_1464_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1255",
      "1801",
      "1559"
    ]
  },
  "FM25001-0200.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindBlockerM_Pageant-1.jpg?v=1757419788",
    "canvas": "1131_637_157_125",
    "defaultPlacement": "1153_647_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1360",
      "1118",
      "1955",
      "1242"
    ]
  },
  "RSC104.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_Charcoal_1.jpg?v=1736282060",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_800_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "CS105.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_0992c4f8-9ae8-43b3-ab10-ddd0af62cf1f.jpg?v=1735353415",
    "canvas": "601_735_470_192",
    "defaultPlacement": "782_755_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1051",
      "1851"
    ]
  },
  "BP502.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_c26bd6f7-15b7-4c25-90ee-8cb90ba6f5eb.jpg?v=1735353506",
    "canvas": "853_537_250_250",
    "defaultPlacement": "883_567_200_200",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1225",
      "1673"
    ]
  },
  "DF401.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/HeritageDuffle-Kodiak-2_2.jpg?v=1760367372",
    "canvas": "644_959_824_583",
    "defaultPlacement": "931_1103_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "UT248.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_MoonGray-Olive_2.jpg?v=1736533596",
    "canvas": "997_620_714_554",
    "defaultPlacement": "1264_807_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1969",
      "1800",
      "1801",
      "1257",
      "1086"
    ]
  },
  "UTF306.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Backside_e12ba0d8-8b02-4f62-bfdc-2e2476594ea7.jpg?v=1735361629",
    "canvas": "450_823_1216_980",
    "defaultPlacement": "923_1210_252_252",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1934",
      "1640"
    ]
  },
  "GR229.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Green-1.jpg?v=1749558312",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "805_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1640",
      "1390"
    ]
  },
  "RSC209.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Cedar-1.jpg?v=1760326443",
    "canvas": "231_586_887_593",
    "defaultPlacement": "615_830_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1255",
      "1801",
      "1559"
    ]
  },
  "GR119.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_9d9e3ffd-1a10-4aa5-b82d-b4bc472229b9.jpg?v=1735353533",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "836_870_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1856",
      "1969"
    ]
  },
  "FM25001-0300.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_Windblocker_NS-1.jpg?v=1773795501",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1150_616_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1955",
      "1371"
    ]
  },
  "GR115.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_ea96ae33-36f0-47a5-b70a-e57c9c7ae7bc.jpg?v=1735353530",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "831_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "CS105.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_3b5c7425-a0f0-44ee-9e79-7e1f002cb216.jpg?v=1735353415",
    "canvas": "943_773_470_207",
    "defaultPlacement": "1085_793_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1051",
      "1851"
    ]
  },
  "UTWD304.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_7229777f-c92a-4944-b853-886414ceec88.jpg?v=1735353437",
    "canvas": "920_937_270_270",
    "defaultPlacement": "960_957_230_230",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1118",
      "1670"
    ]
  },
  "JA240-0400.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_WRD_Timber-1.jpg?v=1770827558",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1071",
      "1801",
      "1083",
      "1800",
      "1336"
    ]
  },
  "PS101.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_a92b866d-0bd3-4563-9562-a7c775cefe8a.jpg?v=1735353509",
    "canvas": "1065_590_636_458",
    "defaultPlacement": "1307_773_119_119",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1858",
      "1800"
    ]
  },
  "FM25001-0400.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_Windblocker_Timber-1.jpg?v=1773795530",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1150_616_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1055",
      "1336"
    ]
  },
  "TX103.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Durham-2_Blk.jpg?v=1761259330",
    "canvas": "911_607_977_619",
    "defaultPlacement": "1340_845_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1987",
      "1118",
      "1640",
      "1800"
    ]
  },
  "DF406.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_CLubhouseDuff_Ecru-3_993628e9-6a68-4b4c-9300-a1dc78e0deba.jpg?v=1770753014",
    "canvas": "705_929_750_750",
    "defaultPlacement": "944_1178_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 4,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1255",
      "1622"
    ]
  },
  "PS203.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_e207d6b9-1ee9-4c4e-b4b1-0b04249f9859.jpg?v=1735353510",
    "canvas": "1240_700_300_240",
    "defaultPlacement": "1334_734_123_123",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "BP439.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_DarkGreenRS-1.jpg?v=1749557796",
    "canvas": "677_418_690_336",
    "defaultPlacement": "950_540_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1955",
      "1390"
    ]
  },
  "UT404.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_MoonGray-4.jpg?v=1760378149",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1250_825_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "JT115.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_5070b907-73bb-4ba3-8684-27933de9ef28.jpg?v=1735353584",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "924_1233_255_255",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1072"
    ]
  },
  "RNS109.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CharcoalBlackRed_1.jpg?v=1736282906",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1147",
      "1118",
      "1800"
    ]
  },
  "RNS208.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Durham-2_1.jpg?v=1760326398",
    "canvas": "980_620_700_700",
    "defaultPlacement": "1270_830_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1987",
      "1801",
      "1640",
      "1118"
    ]
  },
  "RD203.LowerBelly": {
    "location": "Lower Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Navy-Red-White.jpg?v=1729181060",
    "canvas": "596_1142_897_676",
    "defaultPlacement": "954_1368_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1147",
      "1118",
      "1640",
      "1243"
    ]
  },
  "RNS202.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_BW-5_7d3fbba3-5338-49be-84ec-a5dff76220d5.jpg?v=1749248215",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1270_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "SB101.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_627dcf59-a73d-41df-a678-d967854b5312.jpg?v=1735353403",
    "canvas": "590_680_1000_1000",
    "defaultPlacement": "850_958_309_309",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1934",
      "1800"
    ]
  },
  "DF601.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ScoutDuff_Black-5.jpg?v=1760634186",
    "canvas": "469_754_1206_850",
    "defaultPlacement": "978_1091_225_225",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1147",
      "1800"
    ]
  },
  "FM25005-0301.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodie_Green-3_6133e08b-ecb2-43aa-aed2-f61da0b40a9f.jpg?v=1773878799",
    "canvas": "935_637_157_128",
    "defaultPlacement": "959_648_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1955",
      "1970"
    ]
  },
  "BP421.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_CorduraCamo_1.jpg?v=1736288479",
    "canvas": "573_1267_881_530",
    "defaultPlacement": "906_1453_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "UTF306.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FieldTote_Charcoal1_1ab7a3e5-8a33-498e-8e9a-cba518577f16.jpg?v=1737429663",
    "canvas": "450_823_1216_980",
    "defaultPlacement": "900_1130_252_252",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1934",
      "1640"
    ]
  },
  "GR223.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_a6cd6a47-6c88-4ed0-9666-1504f7cbeae6.jpg?v=1735353525",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "802_948_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1243",
      "1147",
      "1801",
      "1640",
      "1953"
    ]
  },
  "RB146.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Ranger_Oxford_2.jpg?v=1749656685",
    "canvas": "576_483_1053_949",
    "defaultPlacement": "914_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1800",
      "1243"
    ]
  },
  "BP446.LowerPocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Graystone-1.jpg?v=1760325418",
    "canvas": "550_1177_981_748",
    "defaultPlacement": "945_1450_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1801",
      "1041"
    ]
  },
  "UT247.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_DarkGreen_3.jpg?v=1736533536",
    "canvas": "965_963_725_768",
    "defaultPlacement": "1233_1252_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1578",
      "1103"
    ]
  },
  "JA241-0403.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_WRD_Ecru-1.jpg?v=1770827558",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1336",
      "1083",
      "1072"
    ]
  },
  "BP439.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2BP_DarkGreenRS-2.jpg?v=1749557796",
    "canvas": "909_687_215_215",
    "defaultPlacement": "940_670_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1955",
      "1390"
    ]
  },
  "GB102.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_GearBag_Navy-1.jpg?v=1773749737",
    "canvas": "513_844_1020_667",
    "defaultPlacement": "860_1017_320_320",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1147",
      "1118",
      "1800",
      "1243"
    ]
  },
  "TX103.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Durham-1_Blk.jpg?v=1761259330",
    "canvas": "168_476_1400_830",
    "defaultPlacement": "565_845_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1987",
      "1118",
      "1640",
      "1800"
    ]
  },
  "RB101.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Black_1.jpg?v=1736533850",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "820_730_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1934",
      "1800"
    ]
  },
  "RB142.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_HeritageWhite_2.jpg?v=1772473878",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "BP447.UpperPocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Seacrest-1.jpg?v=1760326674",
    "canvas": "677_418_690_336",
    "defaultPlacement": "950_580_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1975",
      "1801",
      "1800",
      "1118",
      "1246"
    ]
  },
  "RSC104.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_Charcoal_2.jpg?v=1736282060",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "GJ138.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_NavyWhite_3.jpg?v=1736374230",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1030_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "BP602.FrontPocket": {
    "location": "Front Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityBackpackBurntClay1copy_9a5a38a4-8256-49a7-a5f5-77f9754cc0d8.jpg?v=1734748403",
    "canvas": "611_1102_862_711",
    "defaultPlacement": "902_1250_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1648",
      "1899"
    ]
  },
  "UT413.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Fescue-4.jpg?v=1760378449",
    "canvas": "997_605_714_554",
    "defaultPlacement": "1270_820_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1559",
      "1255"
    ]
  },
  "BP407.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_MoonGray_2.jpg?v=1736288168",
    "canvas": "625_510_799_536",
    "defaultPlacement": "929_670_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1274",
      "1086"
    ]
  },
  "UT403.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_HeritageTrouper_Onyx-5.jpg?v=1758172812",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1255_820_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1640",
      "1138",
      "1800"
    ]
  },
  "BP425.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_BlackSageLeaf_2.jpg?v=1736286754",
    "canvas": "625_510_799_536",
    "defaultPlacement": "929_707_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1138",
      "1578",
      "1801",
      "1640",
      "1800"
    ]
  },
  "GR215.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_497053ed-5e74-43b7-9401-c332a52f9475.jpg?v=1735353524",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "814_921_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1118",
      "1578"
    ]
  },
  "SCB103.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ShortCourse_Charcoal-3.jpg?v=1749246771",
    "canvas": "330_612_937_519",
    "defaultPlacement": "645_820_150_150",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "UTF304.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_4022e111-a73b-406c-aefa-8323c61da33b.jpg?v=1735353451",
    "canvas": "926_1058_255_270",
    "defaultPlacement": "926_1058_255_255",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1072"
    ]
  },
  "RNS104.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_BlackSageLeaf_1.jpg?v=1736282122",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_799_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1116",
      "1578"
    ]
  },
  "FM26027-0302.BackLeftPocket": {
    "location": "Back Left Pocket",
    "picture": "",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "GJ105.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Green_2.jpg?v=1736375090",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_865_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1051",
      "1851"
    ]
  },
  "FM26021-0200.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodieLite_HN-3.jpg?v=1773794956",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1024_592_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1955",
      "1242"
    ]
  },
  "UT403.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_HeritageTrouper_Onyx-6.jpg?v=1758172812",
    "canvas": "1025_1024_732_682",
    "defaultPlacement": "1275_1295_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1640",
      "1138",
      "1800"
    ]
  },
  "JT106.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_b8a223a3-12a9-425e-8f18-fa3eb2974419.png?v=1735353586",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "906_1241_258_258",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1934",
      "1086"
    ]
  },
  "HW201.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Handwarmer_Black_1.jpg?v=1750108906",
    "canvas": "495_836_1057_737",
    "defaultPlacement": "890_1085_285_285",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1934",
      "1800"
    ]
  },
  "RSC202.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_Black-5.jpg?v=1753025945",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1280_840_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "UT251.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper3.0_Azure-4.jpg?v=1749247045",
    "canvas": "354_461_1097_771",
    "defaultPlacement": "616_751_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1082",
      "1801",
      "1640",
      "1175"
    ]
  },
  "RD206.LowerBelly": {
    "location": "Lower Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Navy1.jpg?v=1729181384",
    "canvas": "596_1142_897_676",
    "defaultPlacement": "1001_1368_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "BP111.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_3c91dc26-10d8-4c75-900d-35eb36618ab5.jpg?v=1735353654",
    "canvas": "612_251_797_711",
    "defaultPlacement": "907_460_275_275",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1640",
      "1243"
    ]
  },
  "UT239.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Cobalt_1.jpg?v=1736529793",
    "canvas": "484_554_810_640",
    "defaultPlacement": "617_769_199_199",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1137",
      "1134"
    ]
  },
  "UTWD301.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/WeekenderDuffle_Black_1.jpg?v=1736353297",
    "canvas": "860_1055_250_250",
    "defaultPlacement": "890_1075_215_215",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1147",
      "1118",
      "1800"
    ]
  },
  "RB103.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Navy_2.jpg?v=1772473880",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "820_730_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "BP501.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_9a01e05a-b5c7-404d-81e4-91abae7568b7.jpg?v=1735353504",
    "canvas": "895_574_250_250",
    "defaultPlacement": "923_604_200_200",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "DF603.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ScoutDuff_Charcoal-5.jpg?v=1760377783",
    "canvas": "469_754_1206_850",
    "defaultPlacement": "978_1091_225_225",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1934",
      "1640"
    ]
  },
  "BP429.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_BlackCharcoalRed_1.jpg?v=1736288097",
    "canvas": "573_1267_881_530",
    "defaultPlacement": "906_1453_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1147",
      "1118",
      "1800"
    ]
  },
  "BP421.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_CorduraCamo_1.jpg?v=1736288479",
    "canvas": "677_418_690_360",
    "defaultPlacement": "934_552_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "DK401.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_aeee47f5-fb44-482d-b45a-7aa80f15e8ae.jpg?v=1735353430",
    "canvas": "860_772_360_360",
    "defaultPlacement": "860_772_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "RD209.Upper Belly": {
    "location": "Upper Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Sienna_Rider.jpg?v=1776255922",
    "canvas": "610_559_897_676",
    "defaultPlacement": "960_808_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1138",
      "1112",
      "1225"
    ]
  },
  "JT204.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_PHC_Tote_Espresso1_533e0213-b532-4a28-903e-e26370e4d16f.jpg?v=1753197047",
    "canvas": "501_923_1018_827",
    "defaultPlacement": "920_1164_228_228",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1072",
      "1257",
      "1130"
    ]
  },
  "RNS208.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Durham-3.jpg?v=1761670973",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1987",
      "1801",
      "1640",
      "1118"
    ]
  },
  "BP448.UpperPocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Cedar-1.jpg?v=1760326551",
    "canvas": "677_418_690_336",
    "defaultPlacement": "970_550_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1255",
      "1801",
      "1559"
    ]
  },
  "FM26021-0104.LeftChest": {
    "location": "Left Chest",
    "picture": "",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "BP503.Top": {
    "location": "Top",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Top_de163416-5971-47e8-9301-223835a6ca3c.jpg?v=1735353495",
    "canvas": "879_345_300_300",
    "defaultPlacement": "899_365_276_276",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1072",
      "1801",
      "1640",
      "1578"
    ]
  },
  "PS209.LeftApparelPocket": {
    "location": "Left Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_PS2048_Ecru-3.jpg?v=1768073838",
    "canvas": "989_968_636_458",
    "defaultPlacement": "1260_1125_130_130",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1255",
      "1622"
    ]
  },
  "BP430.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_MoonGrayNavy_1.jpg?v=1736287567",
    "canvas": "569_412_857_512",
    "defaultPlacement": "920_565_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1118",
      "1243",
      "1801",
      "1086"
    ]
  },
  "GR225.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_Charcoal_2.jpg?v=1737046185",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "831_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "HD102.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/GoodieBag_Charcoal_2.jpg?v=1737046338",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "846_1019_400_400",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1147",
      "1801",
      "1934",
      "1640"
    ]
  },
  "UTC308.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_UtilityCooler26_Charcoal-1.jpg?v=1760326697",
    "canvas": "259_402_1554_1460",
    "defaultPlacement": "827_927_421_421",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1934",
      "1640"
    ]
  },
  "RB142.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_HeritageWhite_1.jpg?v=1736533849",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "DK408.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_3765c1df-c2e8-468a-bf14-330954c0b2ab.jpg?v=1735361660",
    "canvas": "780_700_390_390",
    "defaultPlacement": "856_778_285_285",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1118",
      "1800",
      "1243"
    ]
  },
  "RB128.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Sienna_1.jpg?v=1736533849",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1138",
      "1112",
      "1225"
    ]
  },
  "RNS106.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_FieldKhakiCharcoal_2.jpg?v=1736281788",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1082",
      "1801",
      "1578",
      "1041"
    ]
  },
  "GJ105.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Green_3.jpg?v=1736375090",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1065_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1051",
      "1851"
    ]
  },
  "JT203.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_0a81d2cf-f76b-41cf-9c51-75e05ab1cf0a.jpg?v=1735361658",
    "canvas": "501_923_1018_827",
    "defaultPlacement": "914_1164_228_228",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1856",
      "1648",
      "1084"
    ]
  },
  "UTC307.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_UtilityCooler26_Navy-1.jpg?v=1760326716",
    "canvas": "259_402_1554_1460",
    "defaultPlacement": "827_927_421_421",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1640",
      "1243"
    ]
  },
  "UT237.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Navy900d_2.jpg?v=1736529733",
    "canvas": "1006_595_714_554",
    "defaultPlacement": "1274_783_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "BP407.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_MoonGray_1.jpg?v=1736288169",
    "canvas": "693_458_690_336",
    "defaultPlacement": "940_548_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1274",
      "1086"
    ]
  },
  "UT416.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_MGNorthSea-4.jpg?v=1760378037",
    "canvas": "786_569_1092_707",
    "defaultPlacement": "1250_830_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1246",
      "1801",
      "1640",
      "1086"
    ]
  },
  "UT245.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_NavySoftBlue_3.jpg?v=1736533410",
    "canvas": "1017_974_725_768",
    "defaultPlacement": "1285_1264_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1953",
      "1147",
      "1801",
      "1118",
      "1243"
    ]
  },
  "CC101.Top": {
    "location": "Top",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Top_78b8b516-b5b0-4c42-a031-fa35eddba031.jpg?v=1735361615",
    "canvas": "635_740_800_600",
    "defaultPlacement": "885_887_234_234",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "UTWD403.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_WeekenderDuff_SteelBlue_2-1.jpg?v=1749745810",
    "canvas": "505_815_1037_688",
    "defaultPlacement": "930_1075_230_230",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1082",
      "1175"
    ]
  },
  "RSC103.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_DarkGreen_1.jpg?v=1736272757",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_799_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1578",
      "1103"
    ]
  },
  "RNS108.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CharcoalBlackWheat_2.jpg?v=1736282491",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1673",
      "1118",
      "1640"
    ]
  },
  "GR209.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_CharcoalBlack_2.jpg?v=1771248071",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "UT415.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_DarkGreen-5.jpg?v=1760378244",
    "canvas": "978_996_723_758",
    "defaultPlacement": "1264_1285_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1578",
      "1103"
    ]
  },
  "UT414.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_OliveGray-5.jpg?v=1760378219",
    "canvas": "1008_975_725_768",
    "defaultPlacement": "1276_1245_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1255",
      "1640",
      "1668"
    ]
  },
  "GR243.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_PBFK-2.jpg?v=1760327051",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1225",
      "1801",
      "1800",
      "1118",
      "1975"
    ]
  },
  "UT412.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Cedar-3.jpg?v=1760378183",
    "canvas": "299_476_1385_778",
    "defaultPlacement": "660_811_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1255",
      "1801",
      "1559"
    ]
  },
  "BP443.UpperPocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/IMG_0024-22.jpg?v=1759240970",
    "canvas": "759_500_601_439",
    "defaultPlacement": "956_587_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1243",
      "1118",
      "1800",
      "1485"
    ]
  },
  "FM25002-0200.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindPullM_PageantBlue-1.jpg?v=1757419760",
    "canvas": "1218_637_157_128",
    "defaultPlacement": "1240_647_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1360",
      "1801",
      "1118",
      "1800",
      "1242"
    ]
  },
  "GJ138.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_NavyWhite_1.jpg?v=1736374230",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_769_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "TX102.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Navy-1.jpg?v=1760524555",
    "canvas": "168_476_1400_830",
    "defaultPlacement": "555_829_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1041",
      "1640",
      "1375",
      "1243"
    ]
  },
  "BP449.UpperPocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_OliveGray-Fescue-1.jpg?v=1760326615",
    "canvas": "677_418_690_336",
    "defaultPlacement": "965_555_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1668",
      "1987",
      "1801",
      "1800",
      "1255"
    ]
  },
  "RB141.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_DarkGreen_1.jpg?v=1736533850",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1578",
      "1103"
    ]
  },
  "PS209.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_PS2048_Ecru-3.jpg?v=1768073838",
    "canvas": "1065_590_636_458",
    "defaultPlacement": "1330_775_128_128",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1255",
      "1622"
    ]
  },
  "FM26001-0102.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_FTQZ_GB-4.jpg?v=1773794773",
    "canvas": "919_754_120_120",
    "defaultPlacement": "919_754_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1041",
      "1801",
      "1640",
      "1274",
      "1800"
    ]
  },
  "GR235.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_OliveNight-1.jpg?v=1760326785",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "835_975_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1871",
      "1801",
      "1800",
      "1640",
      "1795"
    ]
  },
  "RNS108.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CharcoalBlackWheat_1.jpg?v=1736282491",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1673",
      "1118",
      "1640"
    ]
  },
  "RSC206.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Bone-2.jpg?v=1771866708",
    "canvas": "950_620_740_700",
    "defaultPlacement": "1270_835_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1639",
      "1118",
      "1822"
    ]
  },
  "DF229.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_FieldKhaki_1.jpg?v=1736356205",
    "canvas": "890_975_320_320",
    "defaultPlacement": "960_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1082"
    ]
  },
  "DF230.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_SageLeaf_1.jpg?v=1736356205",
    "canvas": "890_975_320_320",
    "defaultPlacement": "950_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1116",
      "1578"
    ]
  },
  "BP427.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_CementCobalt_1.jpg?v=1736288611",
    "canvas": "573_1267_881_590",
    "defaultPlacement": "943_1453_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1086",
      "1118",
      "1134"
    ]
  },
  "GJ142.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Camo_2_d96b3551-b058-4702-aaca-9120fb954e49.jpg?v=1737039126",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_767_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "GR113.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_Navy_2.jpg?v=1737046185",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "829_960_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "RNS107.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_DarkGreenNavy_1.jpg?v=1736282667",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1243",
      "1390"
    ]
  },
  "RNS105.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CementBondi_1.jpg?v=1736282399",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_801_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1086",
      "1800",
      "1673",
      "1801",
      "1290"
    ]
  },
  "BP503.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Right_9cbf18a8-ad58-4bba-8dcf-0f5761fcff92.jpg?v=1735605670",
    "canvas": "970_585_250_250",
    "defaultPlacement": "990_615_200_200",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1138",
      "1578",
      "1801",
      "1640",
      "1800"
    ]
  },
  "SCB103.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ShortCourse_Charcoal-4.jpg?v=1749246771",
    "canvas": "998_634_728_466",
    "defaultPlacement": "1285_815_155_155",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "TX101.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Graystone-3.jpg?v=1760327278",
    "canvas": "827_1025_757_819",
    "defaultPlacement": "1116_1312_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1668",
      "1041"
    ]
  },
  "HD105.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_feee32ff-56b4-4389-ab7c-7a4e237c068c.jpg?v=1735353456",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "808_1075_393_393",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "UTC306.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_affe74e8-73ba-466f-b5fb-904d8189fe04.jpg?v=1735361595",
    "canvas": "259_402_1554_1460",
    "defaultPlacement": "824_946_421_421",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1856",
      "1969"
    ]
  },
  "RNS202.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_BW-4_4d678d7e-d6cd-4f76-9e6b-683ded8a12ee.jpg?v=1749248215",
    "canvas": "231_586_887_593",
    "defaultPlacement": "610_790_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 4,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "RB127.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_LeCreme_1.jpg?v=1736533849",
    "canvas": "850_762_460_460",
    "defaultPlacement": "860_772_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1072"
    ]
  },
  "FM26033-0901.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_WindblockerTartan_1.jpg?v=1768675013",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1567",
      "1800",
      "1801",
      "1902",
      "1792"
    ]
  },
  "DF405.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/ClubhouseDuffleNavyKodiak-1_5e873ca8-0e5a-4394-b52a-29b6db00bf0e.jpg?v=1760367415",
    "canvas": "625_966_885_674",
    "defaultPlacement": "946_1162_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1118",
      "1800",
      "1243"
    ]
  },
  "TL111.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_bfd1c07a-ee76-4319-b867-a62670dad28a.jpg?v=1735361641",
    "canvas": "515_1430_895_604",
    "defaultPlacement": "674_1749_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "FM25004-0002.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_FleeceVestJB_1.jpg?v=1768675008",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1955",
      "1800"
    ]
  },
  "RB136.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_a1125061-8e81-4ce3-b9d5-cf2c6a4493d2.png?v=1735353551",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1856",
      "1969"
    ]
  },
  "JT107.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_EssToteBack_CH.jpg?v=1744901170",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "890_1250_252_252",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "JT104.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_EssToteBack_Nvy.jpg?v=1744901169",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "883_1253_252_252",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "PS203.LeftApparelPocket": {
    "location": "Left Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Charcoal-R-Players-3_97a17d20-d29c-47e5-9eaf-44c4ecc99000.jpg?v=1734748969",
    "canvas": "989_968_636_458",
    "defaultPlacement": "1290_1110_123_123",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "RB142.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_HeritageWhite_3.jpg?v=1772473878",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "JT201.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_03367c75-672b-4437-958e-fbfb971c3299.jpg?v=1735361663",
    "canvas": "501_923_1018_827",
    "defaultPlacement": "916_1140_228_228",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1856",
      "1648"
    ]
  },
  "DF403.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/HeritageDuffle-White-2_3cc88efd-f048-42f0-b8c6-885fdc7e2033.jpg?v=1760367437",
    "canvas": "646_850_859_668",
    "defaultPlacement": "944_1039_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "SD101.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JonesSportsCo_2025_ScoutDuffleNavy_2-1.jpg?v=1743792764",
    "canvas": "495_740_1057_737",
    "defaultPlacement": "950_1029_216_216",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "HD104.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_694a3a84-05b1-46a4-9424-f15788c78cb9.jpg?v=1735353459",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "821_1068_397_397",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1663",
      "1969",
      "1673"
    ]
  },
  "JT115.Back": {
    "location": "Back",
    "picture": "",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "924_1233_255_255",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1072"
    ]
  },
  "GR243.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_PBFK-1.jpg?v=1760327051",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1255",
      "1801",
      "1800",
      "1118",
      "1975"
    ]
  },
  "RNS206.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_OliveNightBone-2_495ee474-bce9-4143-8130-e84c0734f881.jpg?v=1760325417",
    "canvas": "980_620_700_700",
    "defaultPlacement": "1280_840_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1871",
      "1118",
      "1800",
      "1795"
    ]
  },
  "JT114.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_EssToteBack_Jet.jpg?v=1745959425",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "900_1200_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1858",
      "1800"
    ]
  },
  "PS103.LeftApparelPocket": {
    "location": "Left Apparel Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Jones_Players_Series_003_3_1990d8e9-0930-400e-95bc-a23e5de3b696.png?v=1734749017",
    "canvas": "989_968_636_458",
    "defaultPlacement": "1250_1135_116_116",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1138",
      "1118",
      "1274",
      "1243"
    ]
  },
  "FM25005-0302.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_RangeHoodie-JLoden_1.jpg?v=1768675012",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1955",
      "1156"
    ]
  },
  "GR119.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_Olive_2.jpg?v=1737046185",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "836_870_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1856",
      "1969"
    ]
  },
  "BP406.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_Navy_1.jpg?v=1736287926",
    "canvas": "573_1267_881_530",
    "defaultPlacement": "906_1453_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "RD208.Lower Belly": {
    "location": "Lower Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Rider_Clay_Green_1.jpg?v=1776256068",
    "canvas": "596_1142_897_676",
    "defaultPlacement": "940_1368_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1116",
      "1098"
    ]
  },
  "DF227.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_Charcoalr_1.jpg?v=1736356205",
    "canvas": "890_970_400_400",
    "defaultPlacement": "965_1047_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1243",
      "1977",
      "1640"
    ]
  },
  "DF402.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/HeritageDuffle-Green-2_1.jpg?v=1760367391",
    "canvas": "632_910_824_644",
    "defaultPlacement": "919_1107_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1118",
      "1390"
    ]
  },
  "RNS204.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_SoftBlue-Navy_1.jpg?v=1736281624",
    "canvas": "231_586_887_593",
    "defaultPlacement": "593_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1953",
      "1147",
      "1801",
      "1118",
      "1243"
    ]
  },
  "UT413.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Fescue-3.jpg?v=1760378449",
    "canvas": "315_528_1255_629",
    "defaultPlacement": "666_790_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1559",
      "1255"
    ]
  },
  "GR214.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_CementCobalt_2.jpg?v=1737046184",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "795_968_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1118",
      "1274",
      "1112",
      "1086"
    ]
  },
  "FM25004-0200.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_FleeceVestPBLoden_1.jpg?v=1768675008",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1242",
      "1801",
      "1800",
      "1955",
      "1156"
    ]
  },
  "RB145.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_HeritageGreen_2.jpg?v=1737046135",
    "canvas": "492_483_1053_949",
    "defaultPlacement": "820_759_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1640",
      "1390"
    ]
  },
  "DF223.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_DarkGreen_1.jpg?v=1736356205",
    "canvas": "890_975_320_320",
    "defaultPlacement": "960_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1578",
      "1103"
    ]
  },
  "UT403.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_HeritageTrouper_Onyx-4.jpg?v=1758172812",
    "canvas": "315_528_1255_629",
    "defaultPlacement": "655_765_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1640",
      "1138",
      "1800"
    ]
  },
  "UT416.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_MGNorthSea-3.jpg?v=1760378037",
    "canvas": "299_476_1385_778",
    "defaultPlacement": "680_804_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1246",
      "1801",
      "1640",
      "1086"
    ]
  },
  "UT247.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_DarkGreen_1.jpg?v=1736533536",
    "canvas": "324_420_1097_771",
    "defaultPlacement": "611_761_199_199",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1578",
      "1103"
    ]
  },
  "FM26033-0002.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_LA_RangeQuarter-JB_1.jpg?v=1768675010",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1626_133_250_250",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1041",
      "1801",
      "1640",
      "1955",
      "1800"
    ]
  },
  "SB117.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_bf26dc6f-1224-4abf-af84-bd53706c0b9e.jpg?v=1735353409",
    "canvas": "750_841_502_473",
    "defaultPlacement": "833_909_338_338",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "CS106.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/ClassicStand_White_1.jpg?v=1736534274",
    "canvas": "601_755_470_192",
    "defaultPlacement": "782_770_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1051",
      "1801"
    ]
  },
  "TX101.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_Graystone-2.jpg?v=1760325415",
    "canvas": "911_607_977_619",
    "defaultPlacement": "1312_823_185_185",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1822",
      "1800",
      "1668",
      "1041"
    ]
  },
  "GR301.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_1f613a3c-ab06-4291-98a1-2517fc05c076.jpg?v=1735361586",
    "canvas": "480_777_1087_887",
    "defaultPlacement": "881_1066_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1147",
      "1801",
      "1118",
      "1640"
    ]
  },
  "UT245.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_NavySoftBlue_2.jpg?v=1736533410",
    "canvas": "340_427_1097_771",
    "defaultPlacement": "611_748_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1953",
      "1147",
      "1801",
      "1118",
      "1243"
    ]
  },
  "GR215.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_SageLeaf_2.jpg?v=1737046184",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "814_921_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1118",
      "1578"
    ]
  },
  "GJ146.Belly": {
    "location": "Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_HeritageGreen_3.jpg?v=1736375531",
    "canvas": "350_518_1300_1100",
    "defaultPlacement": "1050_587_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1640",
      "1390"
    ]
  },
  "HD115.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_PHC_Goodie_Espresso1.jpg?v=1745946768",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "840_1060_397_397",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1072",
      "1257",
      "1130"
    ]
  },
  "DK404.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_07e484eb-b9f7-4893-bf69-e6a2b8a4379b.jpg?v=1735361660",
    "canvas": "795_750_360_360",
    "defaultPlacement": "831_797_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1856",
      "1648"
    ]
  },
  "GR245.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Ecru-2.jpg?v=1774742221",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "795_968_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1255",
      "1622"
    ]
  },
  "DK301.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Side_d938458c-7f0e-4741-8796-d7ca16d688e1.jpg?v=1735353434",
    "canvas": "810_780_350_350",
    "defaultPlacement": "847_805_300_300",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1640",
      "1243"
    ]
  },
  "GR208.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_65923be6-ed1e-41cd-b98a-e35444e57223.jpg?v=1735353520",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "814_995_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1072"
    ]
  },
  "CS100-Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/ClassicStand_Black_1_2_432d1829-33ce-4d96-9cd0-ae8eddc7b69f.jpg?v=1733927529",
    "canvas": "1100_851_650_300",
    "defaultPlacement": "1085_793_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": []
  },
  "UT414.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_OliveGray-3.jpg?v=1760378219",
    "canvas": "315_528_1255_629",
    "defaultPlacement": "672_796_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1255",
      "1640",
      "1668"
    ]
  },
  "GJ103.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Navy_1.jpg?v=1736374957",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_749_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1274",
      "1243"
    ]
  },
  "SB108.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_bd629620-3095-4718-ba53-0cb611f1ba57.jpg?v=1735361627",
    "canvas": "176_75_1695_1897",
    "defaultPlacement": "860_941_309_309",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1147",
      "1118",
      "1640",
      "1243"
    ]
  },
  "JT115.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_EssToteBack_Fk.jpg?v=1744901170",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "900_1233_255_255",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1969",
      "1072"
    ]
  },
  "UT402.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_HeritageTrouper_Evergreen-6.jpg?v=1758172831",
    "canvas": "1025_1024_732_682",
    "defaultPlacement": "1301_1290_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1118",
      "1390"
    ]
  },
  "BP448.UnderFlap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_A2_Cedar-2_1.jpg?v=1760326551",
    "canvas": "625_510_799_536",
    "defaultPlacement": "945_665_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1255",
      "1801",
      "1559"
    ]
  },
  "RNS209.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_CedarFescue-3.jpg?v=1760326476",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1822",
      "1559",
      "1801",
      "1255"
    ]
  },
  "RNS107.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_DarkGreenNavy_2.jpg?v=1736282667",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1243",
      "1390"
    ]
  },
  "HD101.Back": {
    "location": "Back",
    "picture": "",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "836_1007_392_392",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1598",
      "1801",
      "1800",
      "1138",
      "1851"
    ]
  },
  "GR211.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_ea58d2b3-ec17-479d-b8c6-28c7cb630dfb.jpg?v=1735353535",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "814_975_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1969",
      "1225",
      "1673"
    ]
  },
  "GR239.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Bone-Cedar-2_1.jpg?v=1760325413",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1559",
      "1800",
      "1118",
      "1255",
      "1822"
    ]
  },
  "GJ147.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_PHC_Original_Espresso4-1.jpg?v=1748399628",
    "canvas": "542_449_963_898",
    "defaultPlacement": "600_755_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1072",
      "1257",
      "1130"
    ]
  },
  "RB102.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Gray_1.jpg?v=1736533850",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "820_735_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1858",
      "1118"
    ]
  },
  "BP424.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_FieldKhakiCharcoal_2.jpg?v=1736288565",
    "canvas": "625_510_799_536",
    "defaultPlacement": "929_692_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1041",
      "1801",
      "1640",
      "1082"
    ]
  },
  "GR237.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Bone-1.jpg?v=1760325414",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_975_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1919",
      "1800",
      "1801",
      "1640",
      "1822"
    ]
  },
  "BP501.Top": {
    "location": "Top",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Top_dc97ea71-dc95-495d-a5fd-db19fd516eaf.jpg?v=1735353502",
    "canvas": "899_306_370_370",
    "defaultPlacement": "919_326_276_276",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "GJ144.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_BurntClay_2.jpg?v=1736375395",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_777_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1648",
      "1899"
    ]
  },
  "UT417.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_Ecru-3.jpg?v=1771866505",
    "canvas": "299_476_1385_778",
    "defaultPlacement": "660_811_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1255",
      "1622"
    ]
  },
  "RSC105.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_Splatter_3.jpg?v=1753028166",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1977",
      "1990",
      "1024",
      "1800"
    ]
  },
  "UT227-4.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JonesSportsCo_Trouper3.0_White_Laydown.jpg?v=1744674483",
    "canvas": "484_540_810_640",
    "defaultPlacement": "615_769_199_199",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1118",
      "1858",
      "1801"
    ]
  },
  "TX106.LeftSide": {
    "location": "Left Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_TrouperProto_ScoutOlive-2.jpg?v=1768602651",
    "canvas": "922_613_829_592",
    "defaultPlacement": "1257_839_185_185",
    "logoList": "",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1856",
      "1969"
    ]
  },
  "RSC201.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_CPT_DG-4.jpg?v=1753025827",
    "canvas": "231_586_887_593",
    "defaultPlacement": "635_840_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1578",
      "1103"
    ]
  },
  "GJ141.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Kodiak_1.jpg?v=1736375132",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_749_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "UT416.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper26_MGNorthSea-5.jpg?v=1760378037",
    "canvas": "978_996_723_758",
    "defaultPlacement": "1275_1275_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1246",
      "1801",
      "1640",
      "1086"
    ]
  },
  "RD202.LowerBelly": {
    "location": "Lower Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Charcoal.jpg?v=1729181060",
    "canvas": "596_1142_897_676",
    "defaultPlacement": "960_1368_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1845",
      "1800"
    ]
  },
  "FM26021-0002.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodieLite_HB-4_73005605-44ab-4058-b8d4-eb0ac8febc92.jpg?v=1773794985",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "945_592_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1955",
      "1800"
    ]
  },
  "GR232.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Onyx-2.jpg?v=1749558249",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "792_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "UT238.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Charcoal_3.jpg?v=1736529431",
    "canvas": "1005_974_725_768",
    "defaultPlacement": "1273_1264_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1851",
      "1640"
    ]
  },
  "RD207.Lower Belly": {
    "location": "Lower Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/AllBlack-Rider.jpg?v=1739830674",
    "canvas": "596_1142_897_676",
    "defaultPlacement": "954_1368_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1118",
      "1147",
      "1800"
    ]
  },
  "BP406.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_Navy_1.jpg?v=1736287926",
    "canvas": "677_418_690_336",
    "defaultPlacement": "934_510_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1274",
      "1243"
    ]
  },
  "FM25005-0101.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_RangeHoodie_Bone-4.jpg?v=1773795682",
    "canvas": "0_0_2048_2048",
    "defaultPlacement": "1045_637_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1955",
      "1970",
      "1072"
    ]
  },
  "BP428.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_SoftBlueNavy_2.jpg?v=1736288370",
    "canvas": "620_547_800_567",
    "defaultPlacement": "929_707_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1243",
      "1147",
      "1801",
      "1640",
      "1953"
    ]
  },
  "FM25001-0202.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindBlockerM_Citadel-1.jpg?v=1757419788",
    "canvas": "1152_651_157_128",
    "defaultPlacement": "1178_7660_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1242",
      "1118",
      "1800",
      "1360"
    ]
  },
  "BP408.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_Charcoal_2.jpg?v=1736287650",
    "canvas": "625_510_799_536",
    "defaultPlacement": "929_695_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1147",
      "1801",
      "1118",
      "1640"
    ]
  },
  "FM25001-0001.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindBlockerM_Black-4.jpg?v=1757419695",
    "canvas": "917_691_166_131",
    "defaultPlacement": "946_702_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1955",
      "1970",
      "1800"
    ]
  },
  "RD204.Upper Belly": {
    "location": "Upper Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Green.jpg?v=1739830674",
    "canvas": "610_559_897_676",
    "defaultPlacement": "960_808_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1051",
      "1851"
    ]
  },
  "RB102.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Ranger_Gray_3.jpg?v=1737046139",
    "canvas": "497_439_1053_949",
    "defaultPlacement": "820_735_399_399",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1858",
      "1118"
    ]
  },
  "UT239.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_Cobalt_3.jpg?v=1736529793",
    "canvas": "1240_1212_242_314",
    "defaultPlacement": "1267_1265_199_199",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1137",
      "1134"
    ]
  },
  "FM25001-0200.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindBlockerM_Pageant-4.jpg?v=1757419695",
    "canvas": "962_612_157_128",
    "defaultPlacement": "987_621_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1360",
      "1118",
      "1955",
      "1242"
    ]
  },
  "UT247.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_DarkGreen_2.jpg?v=1736533536",
    "canvas": "985_572_714_554",
    "defaultPlacement": "1253_767_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1640",
      "1578",
      "1103"
    ]
  },
  "GD106.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Front_8e7e9994-80ed-4c6b-a447-ff262be2ad43.jpg?v=1735353451",
    "canvas": "795_1030_480_480",
    "defaultPlacement": "819_1068_400_400",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1243",
      "1801",
      "1640",
      "1800",
      "1072"
    ]
  },
  "UTC310.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_UtilityCooler26_Black-1.jpg?v=1760326764",
    "canvas": "259_402_1554_1460",
    "defaultPlacement": "827_927_421_421",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1147",
      "1800"
    ]
  },
  "UT241.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_SageLeaf_1.jpg?v=1736529380",
    "canvas": "384_433_1097_771",
    "defaultPlacement": "628_765_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1118",
      "1578"
    ]
  },
  "PS208.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Left_80b28988-f7d6-485e-8af7-8414954c2f6e.jpg?v=1735361656",
    "canvas": "1065_590_636_458",
    "defaultPlacement": "1304_751_128_128",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "GJ141.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_Kodiak_2.jpg?v=1736375132",
    "canvas": "575_456_1000_950",
    "defaultPlacement": "1288_755_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1138",
      "1145"
    ]
  },
  "UT254.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Trouper3.0_MidGray-6.jpg?v=1749246861",
    "canvas": "1020_961_725_768",
    "defaultPlacement": "1285_1265_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1380",
      "1801",
      "1116",
      "1640"
    ]
  },
  "SB105.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Back_74dac375-49e8-4e09-9f72-8165425f95e3.jpg?v=1735353406",
    "canvas": "769_854_508_473",
    "defaultPlacement": "868_931_320_320",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1051",
      "1851"
    ]
  },
  "JT102.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_2025_EssToteBack_Sien.jpg?v=1744901169",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "892_1247_255_255",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1138",
      "1112",
      "1225"
    ]
  },
  "FM26001-0002.LeftSleeve": {
    "location": "Left Sleeve",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_FTQZ_BG-4.jpg?v=1773794915",
    "canvas": "927_742_120_120",
    "defaultPlacement": "927_742_120_120",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1147",
      "1041"
    ]
  },
  "SB121.Backside": {
    "location": "Backside",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ShoeBag_Ecru-1.jpg?v=1768531864",
    "canvas": "767_898_474_453",
    "defaultPlacement": "885_958_309_309",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1145",
      "1801",
      "1800",
      "1255",
      "1622"
    ]
  },
  "GR213.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RangefinderPouch_SoftBlue_2.jpg?v=1737046184",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "819_911_442_442",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1801",
      "1934",
      "1086"
    ]
  },
  "HD114.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Goodie-Bag-Natural-2_e7fe9abe-ab6d-4dac-8d83-f9a340f98790.jpg?v=1734748432",
    "canvas": "385_813_1193_931",
    "defaultPlacement": "821_1069_397_397",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1856",
      "1648",
      "1084"
    ]
  },
  "RSC206.Right": {
    "location": "Right",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RoverStand_Bone-1.jpg?v=1771866708",
    "canvas": "231_586_887_593",
    "defaultPlacement": "620_845_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1640",
      "1639",
      "1118",
      "1822"
    ]
  },
  "GJ144.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Original_BurntClay_1.jpg?v=1736375393",
    "canvas": "542_449_963_898",
    "defaultPlacement": "612_760_166_166",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1084",
      "1648",
      "1899"
    ]
  },
  "FM25001-0001.LeftChest": {
    "location": "Left Chest",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/FO_WindBlockerM_Black-1.jpg?v=1757419788",
    "canvas": "1178_687_196_181",
    "defaultPlacement": "1167_631_109_109",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1640",
      "1955",
      "1970",
      "1800"
    ]
  },
  "RNS203.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_OliveLeCreme_3.jpg?v=1755376842",
    "canvas": "1193_1405_330_330",
    "defaultPlacement": "1257_1466_195_195",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1072",
      "1056",
      "1801",
      "1969"
    ]
  },
  "BP408.Upper Pocket": {
    "location": "Upper Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_Charcoal_1.jpg?v=1736287650",
    "canvas": "665_416_717_411",
    "defaultPlacement": "934_540_165_165",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1147",
      "1801",
      "1118",
      "1640"
    ]
  },
  "RD204.Middle Belly": {
    "location": "Middle Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Rider-Green.jpg?v=1739830674",
    "canvas": "610_839_897_676",
    "defaultPlacement": "960_1088_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1800",
      "1118",
      "1051",
      "1851"
    ]
  },
  "UT241.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_SageLeaf_2.jpg?v=1736529380",
    "canvas": "979_602_714_554",
    "defaultPlacement": "1246_789_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1118",
      "1578"
    ]
  },
  "BP420.Under Flap": {
    "location": "Under Flap",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_MoonGrayBlack_2.jpg?v=1736288329",
    "canvas": "625_510_799_536",
    "defaultPlacement": "920_702_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1851",
      "1086"
    ]
  },
  "GR238.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Cedar-1.jpg?v=1760326894",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "821_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1822",
      "1800",
      "1255",
      "1801",
      "1559"
    ]
  },
  "UT244.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/Trouper_BlackRed_3.jpg?v=1736533470",
    "canvas": "1008_975_725_768",
    "defaultPlacement": "1276_1265_190_190",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1147",
      "1801",
      "1118",
      "1858",
      "1800"
    ]
  },
  "RNS101.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/RoverStand_BlackWheat_2.jpg?v=1736282550",
    "canvas": "902_598_887_593",
    "defaultPlacement": "1256_805_180_180",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 3,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1225",
      "1673"
    ]
  },
  "JT103.Back": {
    "location": "Back",
    "picture": "",
    "canvas": "514_858_1018_827",
    "defaultPlacement": "900_1247_255_255",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1116",
      "1098"
    ]
  },
  "GR229.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Green-2.jpg?v=1749558312",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "792_946_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1118",
      "1640",
      "1390"
    ]
  },
  "RD208.Upper Belly": {
    "location": "Upper Belly",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_Rider_Clay_Green_1.jpg?v=1776256068",
    "canvas": "610_559_897_676",
    "defaultPlacement": "945_808_179_179",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1801",
      "1640",
      "1116",
      "1098"
    ]
  },
  "DF601.Front": {
    "location": "Front",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_ScoutDuff_Black-4.jpg?v=1760634186",
    "canvas": "469_901_1109_674",
    "defaultPlacement": "948_1122_225_225",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1640",
      "1147",
      "1800"
    ]
  },
  "PS201.Left": {
    "location": "Left",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_PlayersSeries_Sonoma.jpg?v=1768943881",
    "canvas": "1065_590_636_458",
    "defaultPlacement": "1295_769_130_130",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1784",
      "1800",
      "1118",
      "1243",
      "1801"
    ]
  },
  "BP408.Lower Pocket": {
    "location": "Lower Pocket",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/A2Backpack_Charcoal_1.jpg?v=1736287650",
    "canvas": "586_1242_846_596",
    "defaultPlacement": "900_1445_210_210",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1147",
      "1801",
      "1118",
      "1640"
    ]
  },
  "DF225.Side": {
    "location": "Side",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/VarsityDuffle_Navy_1.jpg?v=1736356205",
    "canvas": "800_975_550_500",
    "defaultPlacement": "960_1047_240_240",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1801",
      "1118",
      "1800",
      "1934",
      "1243"
    ]
  },
  "GR237.Back": {
    "location": "Back",
    "picture": "https://cdn.shopify.com/s/files/1/0819/3910/4058/files/JSC_RFPouch_Bone-2.jpg?v=1760326831",
    "canvas": "433_578_1208_1118",
    "defaultPlacement": "805_982_429_429",
    "logoList": "list_1",
    "switchy": "lightColor",
    "hooper": 0,
    "swatchColor": "",
    "threadCodes": [
      "1800",
      "1919",
      "1801",
      "1640",
      "1822"
    ]
  }
};